
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("hYhFV", function(module, exports) {
$parcel$export(module.exports, "RootEntrypointWrapper", () => $7d06b64bd0755483$export$40adc4cb138cacb1);

var $eJOHy = parcelRequire("eJOHy");

var $dZ3z2 = parcelRequire("dZ3z2");
const $7d06b64bd0755483$export$40adc4cb138cacb1 = ({ props: props, queries: { rootUiModificationsQuery: rootUiModificationsQuery } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dZ3z2.UiModificationsRoot), {
        ...props,
        queryReference: rootUiModificationsQuery
    });
};

});
parcelRegister("dZ3z2", function(module, exports) {
$parcel$export(module.exports, "UiModificationsRoot", () => $dae652843c10e3eb$export$da1a4f52b34addd2);

var $gt9Am = parcelRequire("gt9Am");

var $39Dwh = parcelRequire("39Dwh");
parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $j4oe4 = parcelRequire("j4oe4");

var $7aIpN = parcelRequire("7aIpN");

var $4SHYP = parcelRequire("4SHYP");
const $dae652843c10e3eb$export$da1a4f52b34addd2 = (props)=>{
    const { queryReference: queryReference } = props;
    if (!queryReference) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7aIpN.default), {
        name: "ui-modifications-root-query",
        fallback: null,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($dae652843c10e3eb$var$RootQuery, {
            ...props,
            queryReference: queryReference
        })
    });
};
const $dae652843c10e3eb$var$RootQuery = (props)=>{
    (0, $gRw8I.di)((0, $4SHYP.UiModificationsRootFragment));
    const { queryReference: queryReference, ...restProps } = props;
    const data = (0, $j4oe4.usePreloadedQuery)((0, $39Dwh.default), queryReference);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4SHYP.UiModificationsRootFragment), {
        ...restProps,
        fragmentRef: data
    });
};

});
parcelRegister("4SHYP", function(module, exports) {
$parcel$export(module.exports, "UiModificationsRootFragment", () => $850ad280bd241c88$export$c460318ed1ecaf23);

var $gt9Am = parcelRequire("gt9Am");

var $bATlU = parcelRequire("bATlU");

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $j4oe4 = parcelRequire("j4oe4");

var $3eWHA = parcelRequire("3eWHA");

var $9h2ZZ = parcelRequire("9h2ZZ");

var $aMlbT = parcelRequire("aMlbT");

var $kn9fY = parcelRequire("kn9fY");

var $ltRMd = parcelRequire("ltRMd");

var $6m5hL = parcelRequire("6m5hL");

var $2GHxY = parcelRequire("2GHxY");

var $5XQre = parcelRequire("5XQre");

var $rh0Fi = parcelRequire("rh0Fi");

var $220X3 = parcelRequire("220X3");
const $850ad280bd241c88$export$c460318ed1ecaf23 = (props)=>{
    const executionContext = (0, $220X3.useEnrichedExecutionContext)({
        executionContext: props.executionContext
    });
    const { executionContextKey: executionContextKey, triggerPointKey: triggerPointKey } = props;
    const viewType = (0, $kn9fY.useViewType)();
    const { setShouldUiModificationsLoad: setShouldUiModificationsLoad } = (0, $9h2ZZ.useAdjustmentsContextActions)();
    const shouldLoad = executionContext && executionContextKey && (0, $6m5hL.isTriggerPointSupported)(viewType, triggerPointKey) && (0, $6m5hL.isExecutionContextSupported)(executionContext);
    (0, $eJOHy.useEffect)(()=>{
        // `executionContextKey` has to be the dependency of the useEffect
        // to set the shouldUiModificationsLoad state according to context changes
        // that is represented by the `executionContextKey`
        if (shouldLoad) setShouldUiModificationsLoad(shouldLoad ? 'yes' : 'no');
    }, [
        setShouldUiModificationsLoad,
        shouldLoad,
        executionContextKey
    ]);
    if (!shouldLoad) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)($850ad280bd241c88$var$RootFragmentWithCleanup, {
        ...props,
        executionContext: executionContext,
        executionContextKey: executionContextKey
    });
};
/**
 * It is separated from
 * - `UiModificationsRootFragment` to run cleanup only when we know that we want to render UIM
 * - `RootFragment` to run cleanup imidiately without awaiting for the new Relay data when context changed
 */ const $850ad280bd241c88$var$RootFragmentWithCleanup = (props)=>{
    (0, $gRw8I.di)((0, $3eWHA.default));
    const { cloudId: cloudId, activationId: activationId, executionContextKey: executionContextKey, triggerPointKey: triggerPointKey, executionContext: executionContext, numberOfSupportedFields: numberOfSupportedFields, resetFormFieldsCounter: resetFormFieldsCounter } = props;
    (0, $rh0Fi.useContextCleanup)({
        executionContextKey: executionContextKey,
        numberOfSupportedFields: numberOfSupportedFields,
        resetFormFieldsCounter: resetFormFieldsCounter
    });
    const tenantContext = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            activationId: activationId
        }), [
        cloudId,
        activationId
    ]);
    const analyticsContextData = (0, $eJOHy.useMemo)(()=>({
            attributes: {
                triggerPointKey: triggerPointKey
            }
        }), [
        triggerPointKey
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3eWHA.default), {
        data: analyticsContextData,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aMlbT.ExecutionContextProvider), {
            value: executionContext,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ltRMd.TenantContextProvider), {
                value: tenantContext,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)($850ad280bd241c88$var$RootFragment, {
                    ...props
                })
            })
        })
    });
};
const $850ad280bd241c88$var$RootFragment = ({ fragmentRef: fragmentRef, ForgeAppRenderer: ForgeAppRenderer, executionContextKey: executionContextKey })=>{
    (0, $gRw8I.di)((0, $2GHxY.AppsRenderer));
    const response = (0, $j4oe4.useFragment)(/* eslint-disable @atlassian/relay/unused-fields */ (0, $bATlU.default), /* eslint-enable @atlassian/relay/unused-fields */ fragmentRef);
    const appsToRender = (0, $5XQre.useAppsToRender)({
        data: response,
        executionContextKey: executionContextKey
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2GHxY.AppsRenderer), {
        apps: appsToRender,
        ForgeAppRenderer: ForgeAppRenderer
    });
};

});
parcelRegister("bATlU", function(module, exports) {
$parcel$export(module.exports, "default", () => $22838c4d41f27885$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0d4369f19f2aa2d86b1af0d493510b82>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $22838c4d41f27885$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "type"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "forgeExtensionRenderingContext"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "uiModificationsContext"
            }
        ],
        "kind": "Fragment",
        "name": "fragment_AtlassianUiModificationsCore_RootFragment",
        "selections": [
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "context",
                                    "variableName": "uiModificationsContext"
                                }
                            ],
                            "concreteType": "JiraAppUiModifications",
                            "kind": "LinkedField",
                            "name": "uiModifications",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "appEnvId"
                                },
                                {
                                    "concreteType": "JiraUiModification",
                                    "kind": "LinkedField",
                                    "name": "uiModifications",
                                    "plural": true,
                                    "selections": [
                                        v0 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "data"
                                        }
                                    ]
                                }
                            ]
                        },
                        "action": "NONE",
                        "path": "jira.uiModifications"
                    },
                    {
                        "concreteType": "JiraForgeQuery",
                        "kind": "LinkedField",
                        "name": "forge",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "uiModificationsExtensions",
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudId",
                                            "variableName": "cloudId"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "context",
                                            "variableName": "forgeExtensionRenderingContext"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "jira:uiModifications"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraForgeExtension",
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v0 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "appVersion"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "installationId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "environmentId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "environmentType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "environmentKey"
                                        },
                                        {
                                            "concreteType": "JiraForgeExtensionLicense",
                                            "kind": "LinkedField",
                                            "name": "license",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "active"
                                                },
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "supportEntitlementNumber"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "trialEndDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "subscriptionEndDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEvaluation"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "billingPeriod"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "ccpEntitlementId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "ccpEntitlementSlug"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "capabilitySet"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "properties"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopes"
                                        },
                                        v1 /*: any*/ ,
                                        {
                                            "concreteType": "JiraForgeAppEgressDeclaration",
                                            "kind": "LinkedField",
                                            "name": "egress",
                                            "plural": true,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "addresses"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "category"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "inScopeEUD"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraForgeInstallationConfigExtension",
                                            "kind": "LinkedField",
                                            "name": "installationConfig",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "consentUrl"
                                        },
                                        {
                                            "concreteType": "JiraUserAppAccess",
                                            "kind": "LinkedField",
                                            "name": "userAccess",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasAccess"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "enabled"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hiddenBy"
                                        }
                                    ]
                                },
                                "action": "NONE",
                                "path": "jira.forge.uiModificationsExtensions"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$22838c4d41f27885$var$node.hash = "ff48dbe4ed2ab636d857ff6d8fc8b30f";
var $22838c4d41f27885$export$2e2bcd8739ae039 = $22838c4d41f27885$var$node;

});

parcelRegister("aMlbT", function(module, exports) {
$parcel$export(module.exports, "useExecutionContext", () => $8545a93c669a234f$export$b0467ce6d1ed861f);
$parcel$export(module.exports, "ExecutionContextProvider", () => $8545a93c669a234f$export$14f2a780bc6de643);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $8545a93c669a234f$export$7f8a924805594460 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $8545a93c669a234f$export$b0467ce6d1ed861f = ()=>{
    const executionContext = (0, $eJOHy.useContext)($8545a93c669a234f$export$7f8a924805594460);
    if (executionContext === null) throw new Error('executionContext value is null');
    return executionContext;
};
const $8545a93c669a234f$export$14f2a780bc6de643 = ({ children: children, value: value })=>{
    if (!value) throw new Error('ExecutionContextProvider requires a value');
    return /*#__PURE__*/ (0, $gt9Am.jsx)($8545a93c669a234f$export$7f8a924805594460.Provider, {
        value: value,
        children: children
    });
};

});

parcelRegister("ltRMd", function(module, exports) {
$parcel$export(module.exports, "useTenantContext", () => $43d7cc0c6c62850a$export$28e7c557f4d454d9);
$parcel$export(module.exports, "TenantContextProvider", () => $43d7cc0c6c62850a$export$e32355e80a92030c);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $43d7cc0c6c62850a$var$TenantContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $43d7cc0c6c62850a$export$28e7c557f4d454d9 = ()=>{
    const tenantContext = (0, $eJOHy.useContext)($43d7cc0c6c62850a$var$TenantContext);
    if (tenantContext === null) throw new Error('tenantContext value is null');
    return tenantContext;
};
const $43d7cc0c6c62850a$export$e32355e80a92030c = ({ children: children, value: value })=>{
    if (!value) throw new Error('TenantContextProvider requires a value');
    return /*#__PURE__*/ (0, $gt9Am.jsx)($43d7cc0c6c62850a$var$TenantContext.Provider, {
        value: value,
        children: children
    });
};

});

parcelRegister("2GHxY", function(module, exports) {
$parcel$export(module.exports, "AppsRenderer", () => $d5bf53e0c2abff55$export$d013b75640a90b27);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $3eWHA = parcelRequire("3eWHA");

var $4q3QN = parcelRequire("4q3QN");

var $1qoZn = parcelRequire("1qoZn");

var $fLu71 = parcelRequire("fLu71");
const $d5bf53e0c2abff55$export$d013b75640a90b27 = ({ ForgeAppRenderer: ForgeAppRenderer, apps: apps })=>{
    const [triggerFieldInitializationKey] = (0, $1qoZn.useTriggerFieldInitialization)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: apps.map(({ forgeExtension: forgeExtension, uiModificationsConfig: uiModificationsConfig })=>{
            const { appId: appId, environmentId: envId } = (0, $4q3QN.parseExtensionId)(forgeExtension.id);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3eWHA.default), {
                data: {
                    attributes: {
                        appId: appId,
                        envId: envId
                    }
                },
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fLu71.SingleAppRenderer), {
                    forgeExtension: forgeExtension,
                    uiModificationsConfig: uiModificationsConfig,
                    ForgeAppRenderer: ForgeAppRenderer
                })
            }, `${forgeExtension.id}-${triggerFieldInitializationKey}`);
        })
    });
};

});
parcelRegister("4q3QN", function(module, exports) {
$parcel$export(module.exports, "parseExtensionId", () => $ccc3ccfe706e3061$export$bae42cbaf7fa3e1b);

var $63yBZ = parcelRequire("63yBZ");
const $ccc3ccfe706e3061$export$bae42cbaf7fa3e1b = (extensionId)=>{
    const ari = (0, $63yBZ.parse)(extensionId);
    const [appId, environmentId, groupId, moduleKey] = ari.resourceId.split('/');
    return {
        appId: appId,
        environmentId: environmentId,
        groupId: groupId,
        moduleKey: moduleKey
    };
};

});
parcelRegister("63yBZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dnskZ = parcelRequire("dnskZ");

var $ik6eF = parcelRequire("ik6eF");

$dnskZ.__exportStar((parcelRequire("jWqQq")), module.exports);
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ class $468ddf0950beb311$var$InvalidAriError extends Error {
    /**
     * Construct an InvalidAriError given an error message
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {string|undefined} description - The error message
     */ constructor(ariString, description){
        super(`Invalid ari string: ${ariString}${description ? '. ' + description : ''}`);
        this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(this, $468ddf0950beb311$var$InvalidAriError.prototype);
    }
    /**
     * Construct an InvalidAriError given some constraint violations
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
     */ static withConstraintViolations(ariString, violations) {
        return new $468ddf0950beb311$var$InvalidAriError(ariString, violations.map((v)=>v.toString()).join('\n'));
    }
}
module.exports.InvalidAriError = $468ddf0950beb311$var$InvalidAriError;
function $468ddf0950beb311$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
const $468ddf0950beb311$var$basicCharConstraint = $ik6eF.pattern(/^[a-z][a-z.-]*$/);
/**
 * resourceType allows for capitalized letters to support Identity ARIs (`ari:cloud:identity::userGrant/<...>`)
 * It's a violation of the spec, but we still need to support that.
 * See https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0
 */ const $468ddf0950beb311$var$resourceTypeCharConstraints = $ik6eF.pattern(/^[a-z][a-z.-]*$/i);
const $468ddf0950beb311$var$resourceOwnerConstraints = [
    $ik6eF.lengthBetween(3, 255),
    $468ddf0950beb311$var$basicCharConstraint
];
const $468ddf0950beb311$var$resourceTypeConstraints = [
    $ik6eF.lengthBetween(3, 255),
    $468ddf0950beb311$var$resourceTypeCharConstraints
];
const $468ddf0950beb311$var$cloudIdConstraints = [
    $ik6eF.lengthBetween(3, 255)
];
const $468ddf0950beb311$var$siteResourceType = 'site';
const $468ddf0950beb311$var$resourceIdChars = /[\w-._~:@#]/.source;
const $468ddf0950beb311$var$resourceIdConstraints = [
    $ik6eF.pattern(new RegExp(`^${$468ddf0950beb311$var$resourceIdChars}+(/${$468ddf0950beb311$var$resourceIdChars}*)*(;v=${$468ddf0950beb311$var$resourceIdChars}*)*$`))
];
/**
 * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
 * (like those for site wide ARIs) are upgraded to their latest form.
 */ function $468ddf0950beb311$var$upgrade(values) {
    const { resourceId: resourceId, resourceOwner: resourceOwner, cloudId: cloudId } = values;
    // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $468ddf0950beb311$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
class $468ddf0950beb311$var$ResourceIdentifier {
    get cloudId() {
        if (this.resourceType === $468ddf0950beb311$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
        return this.internalCloudId;
    }
    /**
     * Create a new Ari
     *
     * Only the resourceOwner is a required field, any other field can be omitted.
     * Older format types are converted on creation
     *
     * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
     * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
     * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
     * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
     *
     * @throws {InvalidAriError} if the provided segments fail to pass validation
     */ constructor(values){
        const { resourceId: resourceId, resourceOwner: resourceOwner, resourceType: resourceType, cloudId: cloudId } = $468ddf0950beb311$var$upgrade(values);
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
    /**
    * Parse a string as an Ari
    *
    * @param {string} ariString - the string to parse
    * @returns {Ari} the parsed ari
    * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
    */ static parse(ariString) {
        if (!ariString) throw new $468ddf0950beb311$var$InvalidAriError(ariString);
        const match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $468ddf0950beb311$var$InvalidAriError(ariString);
        const terms = match.map((a)=>a && a.length > 0 ? a : undefined);
        const resourceOwner = terms[1];
        if (!resourceOwner) throw new $468ddf0950beb311$var$InvalidAriError(ariString);
        return new $468ddf0950beb311$var$ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    }
    static parseEncoded(encodedAriString) {
        return $468ddf0950beb311$var$parse(decodeURIComponent(encodedAriString));
    }
    /**
     * Converts this Ari to a string.
     */ toString() {
        if (!this.ariString) {
            const resourceId = this.resourceType === $468ddf0950beb311$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            const resourceType = this.resourceType || '';
            const sanitizedCloudId = this.resourceType === $468ddf0950beb311$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = `ari:cloud:${this.resourceOwner}:${sanitizedCloudId}:${resourceType}/${resourceId}`;
        }
        return this.ariString;
    }
    /**
     * Converts this object to its json representation
     */ toJSON() {
        return this.toString();
    }
    /**
     * Checks if this context is the same as another context
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
     */ equals(other) {
        return other instanceof $468ddf0950beb311$var$ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    }
    /**
     * This method checks if the current context contains the other context.
     *
     * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
     * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
     *
     * @param {Ari} other
     * @returns {boolean}
     */ contains(other) {
        return this.matches(new $468ddf0950beb311$var$ResourceIdentifier(other));
    }
    /**
     * Checks if this context is the same as or contains the provided context.
     *
     * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
     *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
     *
     * e.g.
     * ```
     * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
     * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
     */ matches(other) {
        return $468ddf0950beb311$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $468ddf0950beb311$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $468ddf0950beb311$var$siteResourceType && !!other.resourceType || $468ddf0950beb311$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $468ddf0950beb311$var$siteResourceType && !!other.resourceType || $468ddf0950beb311$var$matchesSegment(this.resourceId, other.resourceId));
    }
    validateSiteWide() {
        const { resourceType: resourceType, cloudId: cloudId } = this;
        if (resourceType === $468ddf0950beb311$var$siteResourceType && !cloudId) return new $ik6eF.GeneralValidationError('site wide ARIs must have a cloudId');
    }
    validate() {
        const constraintViolations = [
            $ik6eF.validateField(this, 'resourceOwner', $468ddf0950beb311$var$resourceOwnerConstraints),
            $ik6eF.validateField(this, 'resourceType', $468ddf0950beb311$var$resourceTypeConstraints),
            $ik6eF.validateField(this, 'resourceId', $468ddf0950beb311$var$resourceIdConstraints),
            $ik6eF.validateField(this, 'cloudId', $468ddf0950beb311$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $468ddf0950beb311$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $468ddf0950beb311$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    }
    urlEncode() {
        return encodeURIComponent(this.toString());
    }
    urlDecode() {
        return decodeURIComponent(this.toString());
    }
}
module.exports.ResourceIdentifier = $468ddf0950beb311$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $468ddf0950beb311$var$parse(ariString) {
    return $468ddf0950beb311$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $468ddf0950beb311$var$parse;
/**
 * Parse a URL encoded string as an Ari
 *
 * @param {string} encodedAriString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $468ddf0950beb311$var$parseEncoded(encodedAriString) {
    return $468ddf0950beb311$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $468ddf0950beb311$var$parseEncoded;

});
parcelRegister("ik6eF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eDoz3 = parcelRequire("eDoz3");
class $d56eee7d06fcc64a$var$LengthConstraint {
    constructor(min, max){
        this.min = min;
        this.max = max;
    }
    get description() {
        return `length must be between ${this.min} and ${this.max}`;
    }
    isValid(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    }
}
module.exports.LengthConstraint = $d56eee7d06fcc64a$var$LengthConstraint;
class $d56eee7d06fcc64a$var$RegexConstraint {
    constructor(regex){
        this.regex = regex;
    }
    get description() {
        return `value must match regex ${this.regex.source}`;
    }
    isValid(value) {
        return !value || this.regex.test(value);
    }
}
module.exports.RegexConstraint = $d56eee7d06fcc64a$var$RegexConstraint;
class $d56eee7d06fcc64a$var$GeneralValidationError {
    constructor(error){
        this.error = error;
    }
    toString() {
        return this.error;
    }
}
module.exports.GeneralValidationError = $d56eee7d06fcc64a$var$GeneralValidationError;
class $d56eee7d06fcc64a$var$ConstraintViolation {
    constructor(fieldName, value, constraints){
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
    toString() {
        const constraintSummary = this.constraints.map((c)=>`  - ${c.description}`).join('\n');
        return `'${this.value}' is not a valid value for ${this.fieldName} as it violates the following constraints:\n${constraintSummary}`;
    }
}
module.exports.ConstraintViolation = $d56eee7d06fcc64a$var$ConstraintViolation;
function $d56eee7d06fcc64a$var$lengthBetween(min, max) {
    return new $d56eee7d06fcc64a$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $d56eee7d06fcc64a$var$lengthBetween;
function $d56eee7d06fcc64a$var$pattern(regex) {
    return new $d56eee7d06fcc64a$var$RegexConstraint(regex);
}
module.exports.pattern = $d56eee7d06fcc64a$var$pattern;
function $d56eee7d06fcc64a$var$validateField(object, fieldName, constraints) {
    const value = object[fieldName];
    const violatedConstraints = constraints.map((c)=>{
        return c.isValid(value) ? undefined : c;
    }).filter($eDoz3.isDefined);
    return violatedConstraints.length > 0 ? new $d56eee7d06fcc64a$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $d56eee7d06fcc64a$var$validateField;

});
parcelRegister("eDoz3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasValueAtKey = module.exports.hasPresentKey = module.exports.isFilled = module.exports.isDefined = module.exports.isPresent = void 0;
function $aa77c3314e9d9437$var$isPresent(t) {
    return t !== undefined && t !== null;
}
module.exports.isPresent = $aa77c3314e9d9437$var$isPresent;
function $aa77c3314e9d9437$var$isDefined(t) {
    return t !== undefined;
}
module.exports.isDefined = $aa77c3314e9d9437$var$isDefined;
function $aa77c3314e9d9437$var$isFilled(t) {
    return t !== null;
}
module.exports.isFilled = $aa77c3314e9d9437$var$isFilled;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a defined non-null value under the key `k`.
 *
 * @example
 * ```ts
 * const filesWithUrl = files.filter(file => file.url);
 * files[0].url // In this case, TS might still treat this as undefined/null
 *
 * const filesWithUrl = files.filter(hasPresentKey("url"));
 * files[0].url // TS will know that this is present
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $aa77c3314e9d9437$var$hasPresentKey(k) {
    return function(a) {
        return a[k] !== undefined && a[k] !== null;
    };
}
module.exports.hasPresentKey = $aa77c3314e9d9437$var$hasPresentKey;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a specific value V under a key `k`.
 *
 * @example
 * ```ts
 * type File = { type: "image", imageUrl: string } | { type: "pdf", pdfUrl: string };
 * const files: File[] = [];
 *
 * const imageFiles = files.filter(file => file.type === "image");
 * files[0].type // In this case, TS will still treat it  as `"image" | "pdf"`
 *
 * const filesWithUrl = files.filter(hasValueKey("type", "image" as const));
 * files[0].type // TS will now know that this is "image"
 * files[0].imageUrl // TS will know this is present, because already it excluded the other union members.
 *
 * Note: the cast `as const` is necessary, otherwise TS will only know that type is a string.
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $aa77c3314e9d9437$var$hasValueAtKey(k, v) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(a) {
        return a[k] === v;
    };
}
module.exports.hasValueAtKey = $aa77c3314e9d9437$var$hasValueAtKey;

});


parcelRegister("jWqQq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4ZFVe = parcelRequire("4ZFVe");
var $e84841da69f5e74e$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($e84841da69f5e74e$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
class $e84841da69f5e74e$var$AppFamilyAriError extends Error {
    constructor(message, cause){
        super(message);
        this.cause = cause;
    }
}
module.exports.AppFamilyAriError = $e84841da69f5e74e$var$AppFamilyAriError;
class $e84841da69f5e74e$var$NotAppFamilyAriError extends $e84841da69f5e74e$var$AppFamilyAriError {
    constructor(ari, reason){
        super(`ari is not a valid App family ari: ${ari.toString()} as ${reason}`);
        this.reason = reason;
    }
}
module.exports.NotAppFamilyAriError = $e84841da69f5e74e$var$NotAppFamilyAriError;
class $e84841da69f5e74e$var$NotExpectedAppFamilyAriTypeError extends $e84841da69f5e74e$var$AppFamilyAriError {
    constructor(type, ari, cause){
        super(`App family ari (${ari.toString()}) is not of expected type: ${type}`, cause);
        this.cause = cause;
    }
}
module.exports.NotExpectedAppFamilyAriTypeError = $e84841da69f5e74e$var$NotExpectedAppFamilyAriTypeError;
/**
 * throws NotAppFamilyAriError if not a valid app family ari
 */ function $e84841da69f5e74e$var$parseAppAri(ari) {
    return $4ZFVe.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $e84841da69f5e74e$var$parseAppAri;
function $e84841da69f5e74e$var$createAppAri(json) {
    return new $4ZFVe.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $e84841da69f5e74e$var$createAppAri;

});
parcelRegister("4ZFVe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jWqQq = parcelRequire("jWqQq");

var $63yBZ = parcelRequire("63yBZ");

var $ik6eF = parcelRequire("ik6eF");
const $3a2d60ca363a4626$var$versionPrefix = ';v=';
const $3a2d60ca363a4626$var$uuidRegExpString = '[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}';
const $3a2d60ca363a4626$var$uuidConstraints = [
    $ik6eF.pattern(new RegExp(`^${$3a2d60ca363a4626$var$uuidRegExpString}$`, 'i'))
];
const $3a2d60ca363a4626$var$extensionGroupIdConstraints = [
    $ik6eF.pattern(new RegExp(`^(${$3a2d60ca363a4626$var$uuidRegExpString}|static)$`, 'i'))
];
class $3a2d60ca363a4626$var$AppFamilyAriImpl {
    constructor(json){
        this.json = json;
        this.validate();
    }
    get appId() {
        return this.json.appId;
    }
    get environmentId() {
        return this.json.environmentId;
    }
    get version() {
        return this.json.version;
    }
    get extensionGroupId() {
        return this.json.extensionGroupId;
    }
    get extensionKey() {
        return this.json.extensionKey;
    }
    toJSON() {
        return this.json;
    }
    static parse(ari) {
        const { resourceOwner: resourceOwner, resourceType: resourceType, resourceId: resourceId } = ari;
        if (resourceOwner !== $jWqQq.AppFamilyAri.resourceOwner) throw new $jWqQq.NotAppFamilyAriError(ari, `resourceOwner (${resourceOwner}) must be ${$jWqQq.AppFamilyAri.resourceOwner}`);
        if (!resourceType || $jWqQq.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $jWqQq.NotAppFamilyAriError(ari, `resourceType must be one of ${$jWqQq.AppFamilyAri.appFamilyResourceTypes}`);
        if (!resourceId) throw new $jWqQq.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        const versionIndex = resourceId.indexOf($3a2d60ca363a4626$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($3a2d60ca363a4626$var$versionPrefix) > versionIndex) throw new $jWqQq.NotAppFamilyAriError(ari, 'can only include one version suffix');
        const [mainResourceId, version] = resourceId.split($3a2d60ca363a4626$var$versionPrefix);
        const segments = mainResourceId.split('/').map($3a2d60ca363a4626$var$stripToUndefined);
        if (segments.length > 4) throw new $jWqQq.NotAppFamilyAriError(ari, `no path segments can be added after extensionKey ${segments.slice(4)}`);
        const [appId, environmentId, providedExtensionGroupId, extensionKey] = segments;
        if (!appId) throw new $jWqQq.NotAppFamilyAriError(ari, 'appId must be included');
        const extensionGroupId = providedExtensionGroupId || (resourceType === $jWqQq.AppFamilyAri.extensionGroupResourceType || resourceType === $jWqQq.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $jWqQq.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $jWqQq.NotAppFamilyAriError(ari, `environmentId, extensionGroupId, extensionKey must all be provided for resourceType ${$jWqQq.AppFamilyAri.extensionResourceType}`);
        else if (resourceType === $jWqQq.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $jWqQq.NotAppFamilyAriError(ari, `environmentId, extensionGroupId must all be provided for resourceType ${$jWqQq.AppFamilyAri.extensionGroupResourceType}`);
        else if (resourceType === $jWqQq.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $jWqQq.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$jWqQq.AppFamilyAri.environmentResourceType}`);
        else if (resourceType === $jWqQq.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $jWqQq.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$jWqQq.AppFamilyAri.environmentResourceType}`);
        return new $3a2d60ca363a4626$var$AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    }
    asAppAri() {
        return this.returnIf(()=>this.isAppAri(), 'app');
    }
    asAppEnvironmentAri() {
        return this.returnIf(()=>this.isAppEnvironmentAri(), 'environment');
    }
    asExtensionGroupAri() {
        return this.returnIf(()=>this.isExtensionGroupAri(), 'extension-group');
    }
    asExtensionAri() {
        return this.returnIf(()=>this.isExtensionAri(), 'extension');
    }
    isAppAri() {
        return !this.isAtLeastAppEnvironmentAri;
    }
    isAppEnvironmentAri() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    }
    isExtensionGroupAri() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    }
    isExtensionAri() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    }
    returnIf(check, type) {
        if (!check()) throw new $jWqQq.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    }
    get isAtLeastAppEnvironmentAri() {
        return this.environmentId !== undefined;
    }
    get isAtLeastExtensionGroupAri() {
        return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
    }
    validate() {
        const constraintViolations = [
            $ik6eF.validateField(this, 'environmentId', $3a2d60ca363a4626$var$uuidConstraints),
            $ik6eF.validateField(this, 'appId', $3a2d60ca363a4626$var$uuidConstraints),
            $ik6eF.validateField(this, 'extensionGroupId', $3a2d60ca363a4626$var$extensionGroupIdConstraints)
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $63yBZ.InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
    }
    toAri() {
        const resourceOwner = $jWqQq.AppFamilyAri.resourceOwner;
        const { appId: appId, environmentId: environmentId, extensionGroupId: extensionGroupId, extensionKey: extensionKey, version: version } = this.toJSON();
        function withVersion(segments) {
            const path = segments.join('/');
            if (!version) return path;
            else return `${path}${$3a2d60ca363a4626$var$versionPrefix}${version}`;
        }
        if (this.isExtensionAri()) return new $63yBZ.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $jWqQq.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $63yBZ.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $jWqQq.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $63yBZ.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $jWqQq.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $63yBZ.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $jWqQq.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    }
    toString() {
        return this.toAri().toString();
    }
}
module.exports.AppFamilyAriImpl = $3a2d60ca363a4626$var$AppFamilyAriImpl;
function $3a2d60ca363a4626$var$stripToUndefined(str) {
    if (!str) return undefined;
    const trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});




parcelRegister("fLu71", function(module, exports) {
$parcel$export(module.exports, "SingleAppRenderer", () => $0026f3a06a1cb4cb$export$53c5b0cb268c246d);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7aIpN = parcelRequire("7aIpN");

var $4q3QN = parcelRequire("4q3QN");

var $aOOEb = parcelRequire("aOOEb");


var $aMlbT = parcelRequire("aMlbT");

var $kn9fY = parcelRequire("kn9fY");

var $aRf30 = parcelRequire("aRf30");

var $6m5hL = parcelRequire("6m5hL");

var $6laPG = parcelRequire("6laPG");

var $2UZJB = parcelRequire("2UZJB");

var $lkSzY = parcelRequire("lkSzY");

var $3Mk71 = parcelRequire("3Mk71");

var $9sjDw = parcelRequire("9sjDw");
const $0026f3a06a1cb4cb$export$53c5b0cb268c246d = ({ forgeExtension: forgeExtension, uiModificationsConfig: uiModificationsConfig, ForgeAppRenderer: ForgeAppRenderer })=>{
    const { scopes: moduleScopes, id: moduleId } = forgeExtension;
    const { setError: setError } = (0, $aRf30.useIssueAdjustmentsActions)();
    const viewType = (0, $kn9fY.useViewType)();
    const executionContext = (0, $aMlbT.useExecutionContext)();
    const extensionData = (0, $eJOHy.useMemo)(()=>(0, $9sjDw.buildExtensionData)(executionContext), [
        executionContext
    ]);
    const { appId: appId } = (0, $4q3QN.parseExtensionId)(moduleId);
    // This hook can be removed and replaced with `onTimeout` from LazyIframe once
    // https://ecosystem.atlassian.net/browse/BUILD-1617 is done. For now it approximates an
    // iframe timeout if the iframe doesn't use the custom bridge method needed by @forge/jira-bridge
    const { setLoadingComplete: setLoadingComplete } = (0, $2UZJB.useIframeTimeout)({
        forgeExtension: forgeExtension
    });
    const { customBridgeMethods: customBridgeMethods } = (0, $6laPG.useCustomBridgeMethods)({
        onBridgeCommunicationReceived: setLoadingComplete,
        uiModifications: uiModificationsConfig,
        moduleScopes: moduleScopes,
        appId: appId
    });
    const requiredScopesFound = (0, $lkSzY.useScopeChecks)(moduleScopes);
    const currentUIModificationsConsentStatus = (0, $aOOEb.useUIModificationsConsentStatusForApp)({
        appId: appId
    });
    (0, $eJOHy.useEffect)(()=>{
        if (!requiredScopesFound) {
            setError({
                errorCode: 'SCOPES_MISSING_ERROR_CODE'
            });
            setLoadingComplete();
            (0, $6m5hL.getAnalytics)(viewType).cancelTTI();
        }
    }, [
        requiredScopesFound,
        setError,
        setLoadingComplete,
        viewType
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (currentUIModificationsConsentStatus === (0, $8b3b0b63fd2cebd2$export$d67d63332ce3ce38)) {
            setLoadingComplete();
            (0, $6m5hL.getAnalytics)(viewType).cancelTTI();
        }
    }, [
        currentUIModificationsConsentStatus,
        setLoadingComplete,
        viewType
    ]);
    const consentProps = (0, $3Mk71.useThreeLOPromptProps)({
        forgeExtension: forgeExtension
    });
    if (!requiredScopesFound) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7aIpN.default), {
        name: "single-frame-iframe",
        fallback: null,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(ForgeAppRenderer, {
            extension: forgeExtension,
            extensionData: extensionData,
            customBridgeMethods: customBridgeMethods,
            onIframeLoad: (0, $6m5hL.getAnalytics)(viewType).markIframeLoad,
            isIframeResizable: false,
            isIframeHidden: true,
            ...consentProps
        })
    }, moduleId);
};

});
const $8b3b0b63fd2cebd2$export$39d15f3568f5a72c = 'unknown';
const $8b3b0b63fd2cebd2$export$d67d63332ce3ce38 = 'required';
const $8b3b0b63fd2cebd2$export$45ca911896c5084f = 'consented';

parcelRegister("6laPG", function(module, exports) {
$parcel$export(module.exports, "useCustomBridgeMethods", () => $2dc856d18b2be5a7$export$88571489e690a256);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $eJOHy = parcelRequire("eJOHy");


var $3dbnH = parcelRequire("3dbnH");

var $aEhUh = parcelRequire("aEhUh");

var $2CDBc = parcelRequire("2CDBc");

var $fZQzO = parcelRequire("fZQzO");

var $4pRPu = parcelRequire("4pRPu");

var $1qLHy = parcelRequire("1qLHy");
const $2dc856d18b2be5a7$export$88571489e690a256 = ({ onBridgeCommunicationReceived: onBridgeCommunicationReceived, uiModifications: uiModifications, moduleScopes: moduleScopes = [], appId: appId })=>{
    const { onInitPromise: onInitPromise } = (0, $fZQzO.useOnInit)({
        moduleScopes: moduleScopes
    });
    const subscribeToChanges = (0, $aEhUh.useOnChangeSubscription)({
        uiModifications: uiModifications,
        moduleScopes: moduleScopes
    });
    const submit = (0, $1qLHy.useSubmit)({
        moduleScopes: moduleScopes,
        appId: appId
    });
    const registerFields = (0, $4pRPu.useRegisterFields)({
        appId: appId
    });
    const onBridgeError = (0, $3dbnH.useOnBridgeError)({
        appId: appId
    });
    const subscribeToErrors = (0, $2CDBc.useOnErrorSubscription)({
        appId: appId
    });
    const getInternalAPI = (0, $eJOHy.useCallback)(()=>{
        onBridgeCommunicationReceived?.();
        return {
            data: {
                onInitChangeId: (0, $62e8215d7f5c5cb8$export$415cc1afa6445f90),
                uiModifications: uiModifications,
                featureFlags: {
                    // keep as true, we will also need to do the forge-bridge clean-up
                    // and wait for some period of time so the users will migrate to the version without this FG.
                    'forge-ui-modifications-screentabs_qoa33': true
                }
            },
            actions: {
                getOnInitData: ()=>onInitPromise,
                subscribeToChanges: subscribeToChanges,
                submit: submit,
                registerFields: registerFields,
                onBridgeError: onBridgeError,
                subscribeToErrors: subscribeToErrors
            }
        };
    }, [
        onBridgeCommunicationReceived,
        uiModifications,
        subscribeToChanges,
        submit,
        registerFields,
        onInitPromise,
        onBridgeError,
        subscribeToErrors
    ]);
    const customBridgeMethods = (0, $eJOHy.useMemo)(()=>({
            getUiModificationsInternalAPI: getInternalAPI
        }), // TODO: Make sure that the `getInternalAPI` is not being regenerated on the consecutive renders
    // because the bridge consumes only the first version of it, if so clear the array deps to be [].
    [
        getInternalAPI
    ]);
    return {
        customBridgeMethods: customBridgeMethods
    };
};

});
const $62e8215d7f5c5cb8$export$415cc1afa6445f90 = 'onInitChangeId';
const $62e8215d7f5c5cb8$export$811b7f067a43b422 = 'jira:uiModifications';

parcelRegister("3dbnH", function(module, exports) {
$parcel$export(module.exports, "useOnBridgeError", () => $c0676fe971146843$export$7b14c142027ef2e2);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $eJOHy = parcelRequire("eJOHy");

var $546O5 = parcelRequire("546O5");

var $hDiIT = parcelRequire("hDiIT");

var $kn9fY = parcelRequire("kn9fY");

var $aRf30 = parcelRequire("aRf30");

var $6m5hL = parcelRequire("6m5hL");

var $cjgZr = parcelRequire("cjgZr");
const $c0676fe971146843$var$isValidPayload = (payload)=>payload !== undefined && (0, (/*@__PURE__*/$parcel$interopDefault($546O5)))(payload) && (0, $cjgZr.BRIDGE_ERROR_TYPES).includes(payload.error) && (!payload.changeId || typeof payload.changeId === 'string');
const $c0676fe971146843$export$7b14c142027ef2e2 = ({ appId: appId })=>{
    const { setError: setError, unregisterFields: unregisterFields } = (0, $aRf30.useIssueAdjustmentsActions)();
    const viewType = (0, $kn9fY.useViewType)();
    return (0, $eJOHy.useCallback)((payload)=>{
        if (!$c0676fe971146843$var$isValidPayload(payload)) return;
        const { changeId: changeId, error: error, cause: cause } = payload;
        if (changeId) unregisterFields({
            changeId: changeId,
            appId: appId
        });
        setError({
            errorCode: 'ON_BRIDGE_ERROR_ERROR_CODE'
        });
        (0, $6m5hL.getAnalytics)(viewType).stopTTI({
            completionStatus: 'error',
            viewType: viewType
        });
        const UIMLoggableError = new Error(`An ${error} occurred in the UI Modifications code in the Jira Bridge`, {
            cause: cause
        });
        (0, $hDiIT.fireErrorAnalytics)({
            error: UIMLoggableError,
            id: 'UIModificationsJiraBridge',
            viewType: viewType,
            attributes: {
                type: error,
                cause: cause
            }
        });
    }, [
        setError,
        unregisterFields,
        viewType,
        appId
    ]);
};

});
parcelRegister("cjgZr", function(module, exports) {
$parcel$export(module.exports, "BRIDGE_ERROR_TYPES", () => $bb0bc696252ef9c9$export$7845535459d8a620);
const $bb0bc696252ef9c9$export$6634aa68b37142fc = 'onInitError';
const $bb0bc696252ef9c9$export$7ab66e58aded6116 = 'subscribeToChangesError';
const $bb0bc696252ef9c9$export$3018e0c759270938 = 'getApiError';
const $bb0bc696252ef9c9$export$7845535459d8a620 = [
    $bb0bc696252ef9c9$export$6634aa68b37142fc,
    $bb0bc696252ef9c9$export$7ab66e58aded6116,
    $bb0bc696252ef9c9$export$3018e0c759270938
];

});


parcelRegister("aEhUh", function(module, exports) {
$parcel$export(module.exports, "useOnChangeSubscription", () => $ad9a28b3d2aff232$export$785e6020792a124f);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $eJOHy = parcelRequire("eJOHy");

var $iFaP4 = parcelRequire("iFaP4");

var $37KRf = parcelRequire("37KRf");

var $k7beR = parcelRequire("k7beR");

var $jOhDN = parcelRequire("jOhDN");

var $kn9fY = parcelRequire("kn9fY");

var $5jPLd = parcelRequire("5jPLd");

var $gpvWv = parcelRequire("gpvWv");
const $ad9a28b3d2aff232$export$785e6020792a124f = ({ uiModifications: uiModifications, moduleScopes: moduleScopes })=>{
    const viewType = (0, $kn9fY.useViewType)();
    const notifyAppRef = (0, $eJOHy.useRef)(null);
    const { lastProcessedChange: lastProcessedChange } = (0, $jOhDN.useLastProcessedChange)();
    const { currentFormState: currentFormState, currentScreenTabsState: currentScreenTabsState } = (0, $k7beR.useCurrentFormState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iFaP4.useAnalyticsEvents)();
    /**
	 * Single ref for all data that must be up-to-date but not trigger notification.
	 */ const dataRef = (0, $eJOHy.useRef)({
        currentFormState: currentFormState,
        currentScreenTabsState: currentScreenTabsState,
        uiModifications: uiModifications,
        moduleScopes: moduleScopes,
        viewType: viewType
    });
    dataRef.current = {
        currentFormState: currentFormState,
        currentScreenTabsState: currentScreenTabsState,
        uiModifications: uiModifications,
        moduleScopes: moduleScopes,
        viewType: viewType
    };
    (0, $eJOHy.useEffect)(()=>{
        const notifyApp = notifyAppRef.current;
        if (notifyApp === null || lastProcessedChange === null) return;
        const changeId = lastProcessedChange.changeId;
        notifyApp({
            changedFieldId: lastProcessedChange.fieldId,
            changeId: changeId,
            currentFormState: (0, $5jPLd.filterFormDataBasedOnScopes)(dataRef.current.currentFormState, dataRef.current.viewType, dataRef.current.moduleScopes),
            currentScreenTabsState: (0, $gpvWv.filterScreenTabsBasedOnReadScopes)(dataRef.current.moduleScopes, dataRef.current.currentScreenTabsState),
            uiModifications: dataRef.current.uiModifications
        });
        (0, $37KRf.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.appNotification',
            attributes: {
                lifecycleEvent: 'change',
                viewType: dataRef.current.viewType
            }
        });
    }, [
        viewType,
        createAnalyticsEvent,
        lastProcessedChange
    ]);
    return (0, $eJOHy.useCallback)((callback)=>{
        notifyAppRef.current = callback;
    }, []);
};

});
parcelRegister("k7beR", function(module, exports) {
$parcel$export(module.exports, "useCurrentFormState", () => $119f78dc341bc722$export$655680d54d70050d);

var $4MchI = parcelRequire("4MchI");
var $iJq0l = parcelRequire("iJq0l");

var $aRf30 = parcelRequire("aRf30");
const $119f78dc341bc722$var$stableEmpty = {};
const $119f78dc341bc722$var$stableEmptyScreenTabsArrray = [];
const $119f78dc341bc722$var$selectCurrentFormState = (0, $4MchI.createSelector)((state)=>state.formData, (state)=>state.screenTabs, (formData, screenTabs)=>{
    if (formData !== null) return {
        currentFormState: formData,
        currentScreenTabsState: screenTabs || $119f78dc341bc722$var$stableEmptyScreenTabsArrray
    };
    return {
        currentFormState: $119f78dc341bc722$var$stableEmpty,
        currentScreenTabsState: $119f78dc341bc722$var$stableEmptyScreenTabsArrray
    };
});
const $119f78dc341bc722$export$655680d54d70050d = (0, $iJq0l.createStateHook)((0, $aRf30.store), {
    selector: $119f78dc341bc722$var$selectCurrentFormState
});

});

parcelRegister("jOhDN", function(module, exports) {
$parcel$export(module.exports, "useLastProcessedChange", () => $f136dd73f5c1e61e$export$e5124fbd2a3221d);

var $iJq0l = parcelRequire("iJq0l");

var $aRf30 = parcelRequire("aRf30");
const $f136dd73f5c1e61e$export$e5124fbd2a3221d = (0, $iJq0l.createStateHook)((0, $aRf30.store), {
    // We need to wrap the selected slice of state to overcome react-sweet-state useHook with selector issue.
    // We rely on the strict equality of lastUserTriggeredChange (the structure of this object
    // will not change on consecutive updates to a given field but the reference will)
    // https://github.com/atlassian/react-sweet-state/issues/167
    selector: (state)=>({
            lastProcessedChange: state.lastProcessedChange
        })
});

});

parcelRegister("5jPLd", function(module, exports) {
$parcel$export(module.exports, "filterFormDataBasedOnScopes", () => $dc166792fb629add$export$cd9f8248b807046e);
$parcel$export(module.exports, "filterFieldsChangesBasedOnScopes", () => $dc166792fb629add$export$51fbc854b278b1ff);

var $6m5hL = parcelRequire("6m5hL");
const $dc166792fb629add$export$4596199abc4d582e = (viewType, fieldType, moduleScopes)=>{
    const fieldRequiredScopes = (0, $6m5hL.getSupportedFieldConfiguration)(viewType, fieldType)?.requiredScopes;
    if (!fieldRequiredScopes) return true;
    const includeCoarseScopes = ()=>fieldRequiredScopes.coarse.length && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - requiredScope is not types on CI somehow
        fieldRequiredScopes.coarse.every((requiredScope)=>moduleScopes.includes(requiredScope));
    const includeGranularScopes = ()=>fieldRequiredScopes.granular.length && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - requiredScope is not types on CI somehow
        fieldRequiredScopes.granular.every((requiredScope)=>moduleScopes.includes(requiredScope));
    return includeCoarseScopes() || includeGranularScopes();
};
const $dc166792fb629add$export$cd9f8248b807046e = (formData, viewType, moduleScopes)=>{
    const formDataAsArray = Object.entries(formData);
    const filteredFormDataArray = formDataAsArray.filter(([_, value])=>{
        if (!value?.fieldType) return false;
        const { fieldType: fieldType } = value;
        return $dc166792fb629add$export$4596199abc4d582e(viewType, fieldType, moduleScopes);
    });
    return Object.fromEntries(filteredFormDataArray);
};
const $dc166792fb629add$export$51fbc854b278b1ff = (fieldsChanges, formData, viewType, moduleScopes)=>{
    const fieldsChangesAsArray = Object.entries(fieldsChanges);
    const filteredFieldsChangesArray = fieldsChangesAsArray.filter(([fieldId])=>{
        const field = formData[fieldId];
        const fieldType = field?.fieldType;
        if (!fieldType) return false;
        return $dc166792fb629add$export$4596199abc4d582e(viewType, fieldType, moduleScopes);
    });
    return Object.fromEntries(filteredFieldsChangesArray);
};

});

parcelRegister("gpvWv", function(module, exports) {
$parcel$export(module.exports, "filterScreenTabsBasedOnReadScopes", () => $347865004482ec85$export$e0e73d6641eefd01);
$parcel$export(module.exports, "moduleIncludesScreenTabsWriteScopes", () => $347865004482ec85$export$6a622a0cc96dcad7);

var $37KRf = parcelRequire("37KRf");

var $gR0al = parcelRequire("gR0al");
const $347865004482ec85$var$includeCoarseScopes = (requiredScopes, moduleScopes)=>requiredScopes.coarse.length > 0 && requiredScopes.coarse.every((requiredScope)=>moduleScopes.includes(requiredScope));
const $347865004482ec85$var$includeGranularScopes = (requiredScopes, moduleScopes)=>requiredScopes.granular.length > 0 && requiredScopes.granular.every((requiredScope)=>moduleScopes.includes(requiredScope));
const $347865004482ec85$export$e0e73d6641eefd01 = (moduleScopes, screenTabs)=>{
    if ($347865004482ec85$var$includeCoarseScopes((0, $gR0al.baseRequiredReadScopes), moduleScopes) || $347865004482ec85$var$includeGranularScopes((0, $gR0al.baseRequiredReadScopes), moduleScopes)) return screenTabs;
    return [];
};
const $347865004482ec85$export$6a622a0cc96dcad7 = (viewType, createAnalyticsEvent, moduleScopes, screenTabsChanges)=>{
    if ($347865004482ec85$var$includeCoarseScopes((0, $gR0al.baseRequiredWriteScopes), moduleScopes) || $347865004482ec85$var$includeGranularScopes((0, $gR0al.baseRequiredWriteScopes), moduleScopes)) return true;
    if (Array.isArray(screenTabsChanges) && screenTabsChanges.length > 0) (0, $37KRf.fireOperationalEvent)(createAnalyticsEvent, {
        action: 'missingScope',
        actionSubject: 'jiraUiModifications.screenTabs',
        attributes: {
            access: 'write',
            viewType: viewType
        }
    });
    return false;
};

});
parcelRegister("gR0al", function(module, exports) {
$parcel$export(module.exports, "baseRequiredReadScopes", () => $d78137beac9804ed$export$a6bf7d335c3c7d7f);
$parcel$export(module.exports, "baseRequiredWriteScopes", () => $d78137beac9804ed$export$1f346456d218ce0a);
// for reference: https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-screen-tabs/#api-group-screen-tabs
const $d78137beac9804ed$export$a6bf7d335c3c7d7f = {
    granular: [
        'read:screen-tab:jira'
    ],
    coarse: [
        'read:jira-work',
        'manage:jira-configuration',
        'manage:jira-project'
    ]
};
const $d78137beac9804ed$export$1f346456d218ce0a = {
    granular: [
        'write:screen-tab:jira'
    ],
    coarse: [
        'write:jira-work',
        'manage:jira-configuration',
        'manage:jira-project'
    ]
};

});



parcelRegister("2CDBc", function(module, exports) {
$parcel$export(module.exports, "useOnErrorSubscription", () => $7f0e73419345f957$export$97d35fd8c60375e4);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $eJOHy = parcelRequire("eJOHy");

var $jPROM = parcelRequire("jPROM");

var $iFaP4 = parcelRequire("iFaP4");

var $37KRf = parcelRequire("37KRf");

var $5j79b = parcelRequire("5j79b");

var $kn9fY = parcelRequire("kn9fY");

var $aRf30 = parcelRequire("aRf30");
const $7f0e73419345f957$export$97d35fd8c60375e4 = ({ appId: appId })=>{
    const viewType = (0, $kn9fY.useViewType)();
    const notifyAppRef = (0, $eJOHy.useRef)(null);
    const { appErrors: appErrors } = (0, $5j79b.useAppErrors)({
        appId: appId
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iFaP4.useAnalyticsEvents)();
    const { resetAppErrors: resetAppErrors } = (0, $aRf30.useIssueAdjustmentsActions)();
    (0, $eJOHy.useEffect)(()=>{
        const notifyApp = notifyAppRef.current;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(appId) || notifyApp === null || appErrors === null) return;
        notifyApp({
            errors: appErrors
        });
        (0, $37KRf.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.appNotification',
            attributes: {
                lifecycleEvent: 'appError',
                viewType: viewType
            }
        });
        resetAppErrors({
            appId: appId
        });
    }, [
        createAnalyticsEvent,
        resetAppErrors,
        appErrors,
        appId,
        viewType
    ]);
    return (0, $eJOHy.useCallback)((callback)=>{
        notifyAppRef.current = callback;
    }, []);
};

});
parcelRegister("5j79b", function(module, exports) {
$parcel$export(module.exports, "useAppErrors", () => $e46d985195f59d1e$export$535312244836989b);

var $iJq0l = parcelRequire("iJq0l");

var $aRf30 = parcelRequire("aRf30");
const $e46d985195f59d1e$export$535312244836989b = (0, $iJq0l.createStateHook)((0, $aRf30.store), {
    selector: (state, { appId: appId })=>({
            appErrors: state.appsErrors[appId] ?? null
        })
});

});


parcelRegister("fZQzO", function(module, exports) {
$parcel$export(module.exports, "useOnInit", () => $a0b3025f4a079cb9$export$e09230681aa762b4);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $eJOHy = parcelRequire("eJOHy");

var $iFaP4 = parcelRequire("iFaP4");

var $37KRf = parcelRequire("37KRf");

var $hMext = parcelRequire("hMext");

var $kn9fY = parcelRequire("kn9fY");

var $aRf30 = parcelRequire("aRf30");

var $6m5hL = parcelRequire("6m5hL");

var $5jPLd = parcelRequire("5jPLd");

var $gpvWv = parcelRequire("gpvWv");
const $a0b3025f4a079cb9$var$successTabsInitialisation = (createAnalyticsEvent, viewType, screenTabsData)=>{
    if (screenTabsData.length) (0, $37KRf.fireOperationalEvent)(createAnalyticsEvent, {
        action: 'success',
        actionSubject: 'jiraUiModifications.screenTabsInitialization',
        attributes: {
            initializedTabsCount: screenTabsData.length,
            viewType: viewType
        }
    });
};
const $a0b3025f4a079cb9$export$e09230681aa762b4 = ({ moduleScopes: moduleScopes })=>{
    const resolveOnInitPromise = (0, $eJOHy.useRef)(null);
    const viewType = (0, $kn9fY.useViewType)();
    const publicUIMDataForApp = (0, $hMext.useReadyPublicDataForOnInit)({
        viewType: viewType
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iFaP4.useAnalyticsEvents)();
    const { successFieldsInitalisation: successFieldsInitalisation } = (0, $aRf30.useIssueAdjustmentsActions)();
    const onInitPromise = (0, $eJOHy.useMemo)(()=>{
        const promise = new Promise((resolve)=>{
            resolveOnInitPromise.current = resolve;
        });
        promise.then(()=>{
            // It cleans the resolveOnInitPromise to avoid calling the body
            // of the below useEffect after the onInit being resolved once.
            resolveOnInitPromise.current = null;
        });
        return promise;
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        const handleChange = resolveOnInitPromise.current;
        if (publicUIMDataForApp === null || handleChange === null) return;
        const payload = {
            currentFormState: (0, $5jPLd.filterFormDataBasedOnScopes)(publicUIMDataForApp.formData, viewType, moduleScopes),
            currentScreenTabsState: (0, $gpvWv.filterScreenTabsBasedOnReadScopes)(moduleScopes, publicUIMDataForApp.screenTabsData)
        };
        handleChange(payload);
        successFieldsInitalisation({
            createAnalyticsEvent: createAnalyticsEvent
        });
        (0, $37KRf.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.appNotification',
            attributes: {
                lifecycleEvent: 'init',
                viewType: viewType
            }
        });
        $a0b3025f4a079cb9$var$successTabsInitialisation(createAnalyticsEvent, viewType, publicUIMDataForApp.screenTabsData);
        (0, $6m5hL.getAnalytics)(viewType).markOnInitResolved();
    }, [
        successFieldsInitalisation,
        createAnalyticsEvent,
        publicUIMDataForApp,
        moduleScopes,
        viewType
    ]);
    return {
        onInitPromise: onInitPromise
    };
};

});
parcelRegister("hMext", function(module, exports) {
$parcel$export(module.exports, "useReadyPublicDataForOnInit", () => $aa49075ec2b44f4f$export$484a467ba25fea19);

var $iJq0l = parcelRequire("iJq0l");

var $aRf30 = parcelRequire("aRf30");

var $kCzDm = parcelRequire("kCzDm");
const $aa49075ec2b44f4f$export$484a467ba25fea19 = (0, $iJq0l.createStateHook)((0, $aRf30.store), {
    selector: (0, $kCzDm.selectReadyPublicDataForOnInit)
});

});


parcelRegister("4pRPu", function(module, exports) {
$parcel$export(module.exports, "useRegisterFields", () => $509d44d0f2164646$export$fe9a0f40214d6955);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $eJOHy = parcelRequire("eJOHy");

var $kn9fY = parcelRequire("kn9fY");

var $aRf30 = parcelRequire("aRf30");

var $6m5hL = parcelRequire("6m5hL");
const $509d44d0f2164646$export$fe9a0f40214d6955 = ({ appId: appId })=>{
    const { setError: setError, registerFields: registerFields } = (0, $aRf30.useIssueAdjustmentsActions)();
    const viewType = (0, $kn9fY.useViewType)();
    return (0, $eJOHy.useCallback)(async ({ fields: fields, changeId: changeId })=>{
        try {
            // We want to register only fields that are strings.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const validFieldIds = fields.filter((fieldId)=>typeof fieldId === 'string');
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            if (typeof changeId === 'string') registerFields({
                changeId: changeId,
                fieldsToBeRegistered: validFieldIds,
                appId: appId
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setError({
                errorCode: 'USE_REGISTER_FIELDS_ERROR_CODE'
            });
            throw err;
        } finally{
            (0, $6m5hL.getAnalytics)(viewType).markFieldsRegistered();
        }
    }, [
        appId,
        registerFields,
        setError,
        viewType
    ]);
};

});

parcelRegister("1qLHy", function(module, exports) {
$parcel$export(module.exports, "useSubmit", () => $64061c8bd66bc373$export$47c85c6e3a081d3);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $j4oe4 = parcelRequire("j4oe4");

var $iFaP4 = parcelRequire("iFaP4");

var $91hOG = parcelRequire("91hOG");

var $hDiIT = parcelRequire("hDiIT");
var $37KRf = parcelRequire("37KRf");
var $cFn8z = parcelRequire("cFn8z");


var $8ETha = parcelRequire("8ETha");

var $aMlbT = parcelRequire("aMlbT");

var $40DeY = parcelRequire("40DeY");

var $jrVe9 = parcelRequire("jrVe9");

var $jOhDN = parcelRequire("jOhDN");

var $kn9fY = parcelRequire("kn9fY");

var $aRf30 = parcelRequire("aRf30");

var $4NKJm = parcelRequire("4NKJm");

var $ltRMd = parcelRequire("ltRMd");

var $6m5hL = parcelRequire("6m5hL");

var $gpvWv = parcelRequire("gpvWv");

var $lO52R = parcelRequire("lO52R");

var $eFzjI = parcelRequire("eFzjI");
const $64061c8bd66bc373$export$47c85c6e3a081d3 = ({ moduleScopes: moduleScopes, appId: appId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iFaP4.useAnalyticsEvents)();
    const { updateFields: updateFields, setError: setError, unregisterFields: unregisterFields, setAppErrors: setAppErrors, updateScreenTabs: updateScreenTabs, detectAppliedChangesConflicts: detectAppliedChangesConflicts } = (0, $aRf30.useIssueAdjustmentsActions)();
    const viewType = (0, $kn9fY.useViewType)();
    const getAsyncLookupData = (0, $40DeY.useLookupFieldData)();
    const getFilteredFieldChangesBasedOnScope = (0, $eFzjI.useFilterFieldChangesBasedOnScope)(moduleScopes);
    const tenantContext = (0, $ltRMd.useTenantContext)();
    const executionContext = (0, $aMlbT.useExecutionContext)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const getValidatedFieldsChanges = (0, $lO52R.useFieldsChangesValidation)();
    const { lastProcessedChange: lastProcessedChange } = (0, $jOhDN.useLastProcessedChange)();
    const lastChangedProcessRef = (0, $eJOHy.useRef)(lastProcessedChange);
    const formMetadata = (0, $jrVe9.useFormMetadata)();
    const formMetadataRef = (0, $eJOHy.useRef)(formMetadata);
    formMetadataRef.current = formMetadata;
    (0, $eJOHy.useEffect)(()=>{
        lastChangedProcessRef.current = lastProcessedChange;
    }, [
        lastProcessedChange
    ]);
    const intl = (0, $lRq8t.default)();
    return (0, $eJOHy.useCallback)(async ({ fieldsChanges: fieldsChangesUnnormalized, screenTabsChanges: screenTabsChanges, changeId: changeId })=>{
        let isSameFieldValueChanged = false;
        let fieldType = null;
        try {
            const fieldsChanges = getFilteredFieldChangesBasedOnScope(fieldsChangesUnnormalized);
            const validatedFieldsChanges = await getValidatedFieldsChanges(fieldsChanges);
            const lookupDataFromApi = await getAsyncLookupData(validatedFieldsChanges);
            await updateFields({
                changeId: changeId,
                fieldsChanges: fieldsChanges,
                lookupDataFromApi: lookupDataFromApi,
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                appId: appId,
                intl: intl,
                createAnalyticsEvent: createAnalyticsEvent
            });
            if (screenTabsChanges && (0, $gpvWv.moduleIncludesScreenTabsWriteScopes)(viewType, createAnalyticsEvent, moduleScopes, screenTabsChanges)) updateScreenTabs({
                screenTabsChanges: screenTabsChanges,
                appId: appId,
                changeId: changeId
            });
            detectAppliedChangesConflicts({
                appId: appId,
                changeId: changeId
            });
            (0, $6m5hL.getAnalytics)(viewType).stopTTI({
                completionStatus: 'success',
                viewType: viewType
            });
            isSameFieldValueChanged = (0, $8ETha.checkSameFieldValueChanged)(fieldsChanges, lastChangedProcessRef.current, changeId);
            if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $91hOG.fg)('ditto_uim_new_attributes_for_uim_use_submit') && lastChangedProcessRef.current?.fieldId && formMetadataRef.current?.[lastChangedProcessRef.current.fieldId]) {
                const fieldId = lastChangedProcessRef.current.fieldId;
                const { fieldType: fieldTypeFromFormMetadata } = formMetadataRef.current[fieldId];
                fieldType = fieldTypeFromFormMetadata;
            }
            (0, $cFn8z.fireTrackEvent)(createAnalyticsEvent, {
                action: 'success',
                actionSubject: `${viewType}jiraUiModificationsUseSubmit`,
                ...(0, $91hOG.fg)('ditto_uim_new_attributes_for_uim_use_submit') ? {
                    attributes: {
                        isSameFieldValueChanged: isSameFieldValueChanged,
                        isOnInit: changeId === (0, $62e8215d7f5c5cb8$export$415cc1afa6445f90),
                        fieldType: fieldType
                    }
                } : {}
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setError({
                errorCode: 'USE_SUBMIT_ERROR_CODE'
            });
            (0, $6m5hL.getAnalytics)(viewType).stopTTI({
                completionStatus: 'error',
                viewType: viewType
            });
            if (err instanceof (0, $4NKJm.UiModificationsValidationError)) {
                (0, $37KRf.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'failed',
                    actionSubject: 'jiraUiModifications.changesValidation',
                    attributes: {
                        type: err.validationErrorType,
                        ...err.attributes,
                        viewType: viewType
                    }
                });
                // Setting app errors to pass them to the onErrorCallback
                setAppErrors({
                    errors: err.attributes.errors,
                    appId: appId
                });
                return;
            }
            (0, $hDiIT.fireErrorAnalytics)({
                error: err,
                id: 'useSubmit',
                viewType: viewType,
                attributes: {
                    errorCause: err?.cause,
                    ...(0, $91hOG.fg)('ditto_uim_new_attributes_for_uim_use_submit') ? {
                        isSameFieldValueChanged: isSameFieldValueChanged,
                        isOnInit: changeId === (0, $62e8215d7f5c5cb8$export$415cc1afa6445f90),
                        fieldType: fieldType
                    } : {}
                },
                event: createAnalyticsEvent({})
            });
        } finally{
            unregisterFields({
                changeId: changeId,
                appId: appId
            });
        }
    }, [
        getFilteredFieldChangesBasedOnScope,
        getValidatedFieldsChanges,
        getAsyncLookupData,
        updateFields,
        tenantContext,
        executionContext,
        environment,
        appId,
        intl,
        viewType,
        createAnalyticsEvent,
        moduleScopes,
        updateScreenTabs,
        detectAppliedChangesConflicts,
        setError,
        setAppErrors,
        unregisterFields
    ]);
};

});
parcelRegister("cFn8z", function(module, exports) {
$parcel$export(module.exports, "fireTrackEvent", () => $08704e45e717727e$export$574d2f19a52d67ca);

var $6PqvT = parcelRequire("6PqvT");


const $08704e45e717727e$export$574d2f19a52d67ca = (createAnalyticsEvent, eventPayload)=>{
    (0, $6PqvT.default)((0, $0964621a0cb17895$export$8280e5c6104c5b40))({
        ...eventPayload,
        analyticsType: (0, $2105caca302b8178$export$947dac6c72b26f81)
    })(createAnalyticsEvent);
};

});
const $2105caca302b8178$export$f636b5b56f1d624a = 'Screen';
const $2105caca302b8178$export$9d2de6eebf7462b5 = 'Drawer';
const $2105caca302b8178$export$1171103ea9083ffa = 'Modal';
const $2105caca302b8178$export$cae2783c9279926 = 'InlineDialog';
const $2105caca302b8178$export$d1123261ca8831d2 = 'Dropdown';
const $2105caca302b8178$export$a1562d08625f5d7e = 'UI';
const $2105caca302b8178$export$947dac6c72b26f81 = 'TRACK';
const $2105caca302b8178$export$f1d537d508d2945a = 'SCREEN';
const $2105caca302b8178$export$12346a674644c156 = 'OPERATIONAL';
const $2105caca302b8178$export$2ceccf177fae277c = 'analyticsBridge';

const $0964621a0cb17895$export$8280e5c6104c5b40 = 'ui-modifications';


parcelRegister("40DeY", function(module, exports) {
$parcel$export(module.exports, "useLookupFieldData", () => $7e6814a6c9954460$export$d43e9e394c54e784);

var $eJOHy = parcelRequire("eJOHy");

var $jvwCK = parcelRequire("jvwCK");

var $gRw8I = parcelRequire("gRw8I");

var $j4oe4 = parcelRequire("j4oe4");

var $iFaP4 = parcelRequire("iFaP4");


var $d5S3K = parcelRequire("d5S3K");

var $bcGfx = parcelRequire("bcGfx");

var $hD1V6 = parcelRequire("hD1V6");

var $fZ6zP = parcelRequire("fZ6zP");

var $jrVe9 = parcelRequire("jrVe9");

var $kn9fY = parcelRequire("kn9fY");

var $ltRMd = parcelRequire("ltRMd");

var $6m5hL = parcelRequire("6m5hL");
const $7e6814a6c9954460$export$d43e9e394c54e784 = ()=>{
    (0, $gRw8I.di)((0, $j4oe4.useRelayEnvironment), (0, $jrVe9.useFormMetadata), (0, $fZ6zP.fetchUsers), (0, $hD1V6.fetchProjects), (0, $kn9fY.useViewType), (0, $ltRMd.useTenantContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iFaP4.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $ltRMd.useTenantContext)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const formMetadata = (0, $jrVe9.useFormMetadata)();
    const formMetadataRef = (0, $eJOHy.useRef)(formMetadata);
    const viewType = (0, $kn9fY.useViewType)();
    /**
	 * We want to have an up-to-date data when this hook's
	 * returned function is being called in useSubmit callback function
	 * thats why we keep it in a ref object
	 */ formMetadataRef.current = formMetadata;
    return (0, $eJOHy.useCallback)(async (fieldsChanges)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const lookupData = {};
        const asyncFieldsValues = Object.entries(fieldsChanges).reduce((acc, [fieldId, fieldData])=>{
            if (!formMetadataRef.current[fieldId]) return acc;
            const { fieldType: fieldType } = formMetadataRef.current[fieldId];
            const fieldValue = fieldData.value;
            const supportedFieldsConfiguration = (0, $6m5hL.getSupportedFieldConfiguration)(viewType, fieldType);
            const lookupSource = supportedFieldsConfiguration?.lookupSource;
            const isUserLookupField = lookupSource === (0, $24aaf8760f108443$export$3a106242c8f57ac2);
            const isProjectLookupField = lookupSource === (0, $24aaf8760f108443$export$e10d4d251d909c59);
            if (isUserLookupField && fieldValue && (0, $d5S3K.isNotAutomaticId)(fieldValue)) {
                const currentAccountIds = acc.accountIds ? [
                    ...acc.accountIds
                ] : [];
                const newAccountIds = Array.isArray(fieldValue) ? fieldValue : [
                    fieldValue
                ];
                acc.accountIds = [
                    ...currentAccountIds,
                    ...newAccountIds
                ];
            }
            if (isProjectLookupField && fieldValue) {
                const currentProjectIds = acc.projectIds ? [
                    ...acc.projectIds
                ] : [];
                const newProjectIds = Array.isArray(fieldValue) ? fieldValue : [
                    fieldValue
                ];
                acc.projectIds = [
                    ...currentProjectIds,
                    ...newProjectIds
                ];
            }
            /** Add extra checks to add other lookup type e.g. issues lookup */ return acc;
        }, {});
        let users = [];
        let projects = [];
        if (asyncFieldsValues.accountIds) {
            const uniqueAccountIds = (0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))(asyncFieldsValues.accountIds);
            users = await (0, $fZ6zP.fetchUsers)(environment, uniqueAccountIds, createAnalyticsEvent);
        }
        if (asyncFieldsValues.projectIds) {
            const uniqueProjectIds = (0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))(asyncFieldsValues.projectIds);
            // Convert numeric project IDs to ARIs before fetching
            // GraphQL expects ARIs like "ari:cloud:jira:{cloudId}:project/10001", not plain "10001"
            const projectAris = (0, $bcGfx.convertProjectIdsToAris)(uniqueProjectIds, cloudId);
            projects = await (0, $hD1V6.fetchProjects)(environment, projectAris, createAnalyticsEvent);
        }
        lookupData[0, $24aaf8760f108443$export$3a106242c8f57ac2] = users;
        lookupData[0, $24aaf8760f108443$export$e10d4d251d909c59] = projects;
        return lookupData;
    }, [
        createAnalyticsEvent,
        viewType,
        environment,
        cloudId
    ]);
};

});
const $24aaf8760f108443$export$a1cacdcf198da901 = 'LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY';
const $24aaf8760f108443$export$3a106242c8f57ac2 = 'LOOKUP_SOURCE_USERS_ASYNC_DATA';
const $24aaf8760f108443$export$e10d4d251d909c59 = 'LOOKUP_SOURCE_PROJECTS_ASYNC_DATA';
const $24aaf8760f108443$export$f5d5f6bb902f1027 = '-1';
const $24aaf8760f108443$export$106087dcfd4fb129 = 100;

parcelRegister("bcGfx", function(module, exports) {
$parcel$export(module.exports, "convertProjectIdsToAris", () => $fa00e08d4d8a590d$export$2a73bd4f6cc71a00);
/**
 * Converts a project ID to a Jira project ARI.
 *
 * @param projectId - The project ID (numeric string like "10001" or already an ARI)
 * @param cloudId - The cloud/tenant ID
 * @returns The full project ARI in format "ari:cloud:jira:{cloudId}:project/{projectId}"
 *
 * @example
 * ```typescript
 * convertProjectIdToAri("10001", "abc-123-def")
 * // returns: "ari:cloud:jira:abc-123-def:project/10001"
 *
 * convertProjectIdToAri("ari:cloud:jira:abc-123-def:project/10001", "abc-123-def")
 * // returns: "ari:cloud:jira:abc-123-def:project/10001" (unchanged)
 * ```
 */ const $fa00e08d4d8a590d$export$fee909b034ddb326 = (projectId, cloudId)=>{
    // If already an ARI, return as-is
    if (projectId.startsWith('ari:')) return projectId;
    // Convert numeric project ID to ARI format
    return `ari:cloud:jira:${cloudId}:project/${projectId}`;
};
const $fa00e08d4d8a590d$export$2a73bd4f6cc71a00 = (projectIds, cloudId)=>{
    return projectIds.map((id)=>$fa00e08d4d8a590d$export$fee909b034ddb326(id, cloudId));
};

});

parcelRegister("hD1V6", function(module, exports) {
$parcel$export(module.exports, "fetchProjects", () => $016f2f78b6f32aa3$export$f0d2ca471cdb99b0);

var $3UAAM = parcelRequire("3UAAM");

var $j4oe4 = parcelRequire("j4oe4");

var $37KRf = parcelRequire("37KRf");

var $iqHrL = parcelRequire("iqHrL");
const $016f2f78b6f32aa3$export$f0d2ca471cdb99b0 = async (environment, projectIds, createAnalyticsEvent)=>{
    try {
        const apiStartTime = performance.now();
        const response = await (0, $j4oe4.fetchQuery)(environment, /* eslint-disable @atlassian/relay/unused-fields */ (0, $3UAAM.default), {
            projectIds: projectIds
        }, {
            networkCacheConfig: {
                force: false
            },
            fetchPolicy: 'store-or-network'
        }).toPromise();
        if (!response?.jira?.jiraProjects) throw new (0, $iqHrL.ErrorWithStatusCode)('[fetch-projects service] [fetchProjectsQuery]: Property jira.jiraProjects does not exist.', {
            cause: 'FETCH_PROJECTS_MISSING_PROJECTS_PROPERTY'
        }, 'FETCH_PROJECTS_MISSING_PROJECTS_PROPERTY');
        const apiLatencyMs = Math.floor(performance.now() - apiStartTime);
        (0, $37KRf.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModificationsFetchProjects',
            attributes: {
                projectsAPILatency: apiLatencyMs
            }
        });
        return response.jira.jiraProjects.filter((project)=>project !== null && project !== undefined && project.projectId !== null && project.projectId !== undefined).map((project)=>({
                // Use projectId (numeric ID like "10001"), not id (ARI)
                id: project.projectId,
                key: project.key,
                name: project.name,
                avatarUrls: {
                    '48x48': project.avatar?.large || ''
                }
            }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        if (!err.cause) err.cause = 'FETCH_PROJECTS_UNKNOWN_ERROR';
        throw err;
    }
};

});
parcelRegister("3UAAM", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d5f85e44341cbcb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ca9c6c46f782b7f54cd4d0c405c0c310>>
 * @relayHash 8dddd1ce7676474299e324ca788770e3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a35fab1f4b197bcbd5d89a2b7aad018babad3896f53037c9777e0ba46e3a367e
const $1d5f85e44341cbcb$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIds"
        }
    ], v1 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "ids",
                            "variableName": "projectIds"
                        }
                    ],
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jiraProjects",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "projectId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "large"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "fetchProjectsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "fetchProjectsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "a35fab1f4b197bcbd5d89a2b7aad018babad3896f53037c9777e0ba46e3a367e",
            "metadata": {},
            "name": "fetchProjectsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1d5f85e44341cbcb$var$node.hash = "bfbd83d6cfdfb7072506c62a347912b6";
var $1d5f85e44341cbcb$export$2e2bcd8739ae039 = $1d5f85e44341cbcb$var$node;

});

parcelRegister("iqHrL", function(module, exports) {
$parcel$export(module.exports, "ErrorWithStatusCode", () => $828c363fb0402554$export$13144d723cf04c);
class $828c363fb0402554$export$13144d723cf04c extends Error {
    constructor(message, options, statusCode){
        super(message, options);
        this.statusCode = statusCode;
    }
}

});


parcelRegister("fZ6zP", function(module, exports) {
$parcel$export(module.exports, "fetchUsers", () => $52127e9ea0244fa6$export$2bb8333a9210be15);

var $hHGIR = parcelRequire("hHGIR");

var $j4oe4 = parcelRequire("j4oe4");

var $37KRf = parcelRequire("37KRf");

var $iqHrL = parcelRequire("iqHrL");
const $52127e9ea0244fa6$export$2bb8333a9210be15 = async (environment, accountIds, createAnalyticsEvent)=>{
    try {
        const apiStartTime = performance.now();
        const response = await (0, $j4oe4.fetchQuery)(environment, /* eslint-disable @atlassian/relay/unused-fields */ (0, $hHGIR.default), {
            accountIds: accountIds
        }, {
            networkCacheConfig: {
                force: false
            },
            fetchPolicy: 'store-or-network'
        }).toPromise();
        if (!response?.users) throw new (0, $iqHrL.ErrorWithStatusCode)('[fetch-users service] [fetchUsersQuery]: Property users does not exist.', {
            cause: 'FETCH_USERS_MISSING_USERS_PROPERTY'
        }, 'FETCH_USERS_MISSING_USERS_PROPERTY');
        const apiLatencyMs = Math.floor(performance.now() - apiStartTime);
        (0, $37KRf.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModificationsFetchUsers',
            attributes: {
                usersAPILatency: apiLatencyMs
            }
        });
        return [
            ...response.users
        ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        if (!err.cause) err.cause = 'FETCH_USERS_UNKNOWN_ERROR';
        throw err;
    }
};

});
parcelRegister("hHGIR", function(module, exports) {
$parcel$export(module.exports, "default", () => $e710f626e281413d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6109c01c0559b2d0812b75c892a215b7>>
 * @relayHash 8d49f086e404cd774990851cc2a7daa2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f065e1026f784b8accb52074af7bd36e6b06fbe4ba5e8c7e5a6d71afec948def
const $e710f626e281413d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "accountIds"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v4 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "fetchUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "fetchUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "f065e1026f784b8accb52074af7bd36e6b06fbe4ba5e8c7e5a6d71afec948def",
            "metadata": {},
            "name": "fetchUsersQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e710f626e281413d$var$node.hash = "55c7a5d564d3036b3714730d97d87482";
var $e710f626e281413d$export$2e2bcd8739ae039 = $e710f626e281413d$var$node;

});


parcelRegister("jrVe9", function(module, exports) {
$parcel$export(module.exports, "useFormMetadata", () => $c9c8679fddf80c94$export$863414fa128cb7ef);

var $4MchI = parcelRequire("4MchI");
var $iJq0l = parcelRequire("iJq0l");

var $aRf30 = parcelRequire("aRf30");
const $c9c8679fddf80c94$var$selectFormMetadata = (0, $4MchI.createSelector)((state)=>state.internalFormMetadata, (metadata)=>metadata);
const $c9c8679fddf80c94$export$863414fa128cb7ef = (0, $iJq0l.createStateHook)((0, $aRf30.store), {
    selector: $c9c8679fddf80c94$var$selectFormMetadata
});

});


parcelRegister("lO52R", function(module, exports) {
$parcel$export(module.exports, "useFieldsChangesValidation", () => $dc4cc02680f679a9$export$e3505fcc03e08574);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $eJOHy = parcelRequire("eJOHy");

var $iFaP4 = parcelRequire("iFaP4");

var $k7beR = parcelRequire("k7beR");

var $jrVe9 = parcelRequire("jrVe9");

var $kn9fY = parcelRequire("kn9fY");

var $3g7xr = parcelRequire("3g7xr");

var $fVhkv = parcelRequire("fVhkv");
const $dc4cc02680f679a9$var$filterInvalidResults = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);
const $dc4cc02680f679a9$var$mapValidResultsToFieldChangesMap = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === true) {
            const { data: { fieldId: fieldId, fieldData: fieldData } } = result;
            acc[fieldId] = fieldData;
        }
        return acc;
    }, {});
const $dc4cc02680f679a9$export$e3505fcc03e08574 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iFaP4.useAnalyticsEvents)();
    const formMetadata = (0, $jrVe9.useFormMetadata)();
    const formMetadataRef = (0, $eJOHy.useRef)(formMetadata);
    const viewType = (0, $kn9fY.useViewType)();
    const { currentFormState: currentFormState } = (0, $k7beR.useCurrentFormState)();
    const currentFormStateRef = (0, $eJOHy.useRef)(currentFormState);
    /**
	 * We want to have an up-to-date data when this hook's
	 * returned function is being called in useSubmit callback function
	 * thats why we keep it in a ref object
	 */ formMetadataRef.current = formMetadata;
    currentFormStateRef.current = currentFormState;
    return (0, $eJOHy.useCallback)(async (fieldsChanges)=>{
        const fieldsChangesValidationResult = await Promise.all(Object.entries(fieldsChanges).filter(([fieldId])=>{
            return formMetadataRef.current[fieldId] !== undefined;
        }).map(async ([fieldId, fieldData])=>{
            const { fieldType: fieldType } = formMetadataRef.current[fieldId];
            const fieldValidationResult = await (0, $fVhkv.validateFieldChanges)({
                fieldType: fieldType,
                fieldId: fieldId,
                viewType: viewType,
                createAnalyticsEvent: createAnalyticsEvent,
                fieldMetadata: formMetadataRef.current[fieldId],
                currentField: currentFormStateRef.current[fieldId],
                fieldFromIframe: fieldData
            });
            if (fieldValidationResult.isValid === false) return fieldValidationResult;
            return {
                ...fieldValidationResult,
                data: {
                    fieldId: fieldId,
                    fieldData: fieldData
                }
            };
        }));
        const failedValidationResults = $dc4cc02680f679a9$var$filterInvalidResults(fieldsChangesValidationResult);
        if (failedValidationResults.length) throw new (0, $3g7xr.UiModificationsFieldsValidationError)('Validation failed', {
            errors: failedValidationResults.flatMap((result)=>result.errors)
        });
        return $dc4cc02680f679a9$var$mapValidResultsToFieldChangesMap(fieldsChangesValidationResult);
    }, [
        createAnalyticsEvent,
        viewType
    ]);
};

});
parcelRegister("fVhkv", function(module, exports) {
$parcel$export(module.exports, "validateFieldChanges", () => $9ed3358853461e75$export$a2b7ddd7c3d0703a);

var $6m5hL = parcelRequire("6m5hL");

var $f4pOh = parcelRequire("f4pOh");

var $8ZFYe = parcelRequire("8ZFYe");
const $9ed3358853461e75$export$a2b7ddd7c3d0703a = async ({ fieldType: fieldType, fieldId: fieldId, currentField: currentField, fieldFromIframe: fieldFromIframe, fieldMetadata: fieldMetadata, viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
    const fieldConfiguration = (0, $6m5hL.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldValidators = fieldConfiguration?.publicShapeValidators;
    if (!fieldFromIframe || !fieldValidators) return 0, $f4pOh.VALID_RESULT;
    const validatorsArray = Object.entries(fieldValidators);
    const fieldValidationResults = await Promise.all(validatorsArray.map(async ([propertyName, validate])=>{
        if ((0, $8ZFYe.isFieldPropertyName)(fieldFromIframe, propertyName)) {
            const propertyValue = fieldFromIframe[propertyName];
            const validationResult = await validate(propertyValue, fieldMetadata, createAnalyticsEvent, {
                currentField: currentField,
                viewType: viewType
            });
            return (0, $8ZFYe.prepareValidationResult)({
                validationResult: validationResult,
                fieldId: fieldId,
                fieldType: fieldType,
                propertyName: propertyName
            });
        }
        return 0, $f4pOh.VALID_RESULT;
    }));
    const invalidValidationResult = (0, $8ZFYe.filterInvalidResults)(fieldValidationResults);
    if (invalidValidationResult.length > 0) return {
        isValid: false,
        errors: invalidValidationResult.map((result)=>result.error)
    };
    return 0, $f4pOh.VALID_RESULT;
};

});
parcelRegister("f4pOh", function(module, exports) {
$parcel$export(module.exports, "VALID_RESULT", () => $9befd4fb970e90b3$export$ee79e3ab53b8db79);
const $9befd4fb970e90b3$export$ee79e3ab53b8db79 = {
    isValid: true
};

});

parcelRegister("8ZFYe", function(module, exports) {
$parcel$export(module.exports, "prepareValidationResult", () => $d3d8f8a39df1f55c$export$971a38960a5f1064);
$parcel$export(module.exports, "filterInvalidResults", () => $d3d8f8a39df1f55c$export$ddd005554aecd409);
$parcel$export(module.exports, "isFieldPropertyName", () => $d3d8f8a39df1f55c$export$fd744b06c9068a9e);


var $5nB9s = parcelRequire("5nB9s");

var $f4pOh = parcelRequire("f4pOh");
const $d3d8f8a39df1f55c$var$prepareValidationResultByBooleanValue = ({ validationResult: validationResult, fieldId: fieldId, fieldType: fieldType, propertyName: propertyName })=>{
    if (validationResult === false) return {
        isValid: false,
        error: {
            type: (0, $02ee88e62fd0a988$export$d1996cb46a690190),
            method: (0, $5nB9s.mapFieldPropertyToApiMethod)(propertyName),
            fieldId: fieldId,
            fieldType: fieldType
        }
    };
    return 0, $f4pOh.VALID_RESULT;
};
const $d3d8f8a39df1f55c$var$prepareValidationResultByExtendedValue = ({ validationResult: validationResult, fieldId: fieldId, fieldType: fieldType })=>{
    if (validationResult.isValid === false) return {
        isValid: false,
        error: {
            type: (0, $02ee88e62fd0a988$export$d1996cb46a690190),
            method: validationResult.error.method,
            message: validationResult.error.message,
            fieldId: fieldId,
            fieldType: fieldType
        }
    };
    return 0, $f4pOh.VALID_RESULT;
};
const $d3d8f8a39df1f55c$export$971a38960a5f1064 = ({ validationResult: validationResult, fieldId: fieldId, fieldType: fieldType, propertyName: propertyName })=>{
    // We will remove the boolean check and old method after changing all validators to return objects
    if (typeof validationResult === 'boolean') return $d3d8f8a39df1f55c$var$prepareValidationResultByBooleanValue({
        validationResult: validationResult,
        fieldId: fieldId,
        fieldType: fieldType,
        propertyName: propertyName
    });
    return $d3d8f8a39df1f55c$var$prepareValidationResultByExtendedValue({
        validationResult: validationResult,
        fieldId: fieldId,
        fieldType: fieldType
    });
};
const $d3d8f8a39df1f55c$export$ddd005554aecd409 = (validationResults)=>validationResults.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);
const $d3d8f8a39df1f55c$export$fd744b06c9068a9e = (fieldFromIframe, propertyName)=>Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName);

});
const $02ee88e62fd0a988$export$fd26696d109785a0 = 'SCREENTABS_VALIDATION_FAILED';
const $02ee88e62fd0a988$export$d1996cb46a690190 = 'FIELD_VALIDATION_FAILED';
const $02ee88e62fd0a988$export$8042247b663edbcc = 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD';
const $02ee88e62fd0a988$export$2a3fdceaae2188d5 = 'MULTIPLE_APPS_CONFLICT';
const $02ee88e62fd0a988$export$e4ac32edd5da2ee7 = 'FIELD';
const $02ee88e62fd0a988$export$877da1000325f8b5 = 'SCREENTABS';




parcelRegister("eFzjI", function(module, exports) {
$parcel$export(module.exports, "useFilterFieldChangesBasedOnScope", () => $09645cc4a47fe3a9$export$2ee317ef8ccc699f);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $eJOHy = parcelRequire("eJOHy");

var $k7beR = parcelRequire("k7beR");

var $kn9fY = parcelRequire("kn9fY");

var $5jPLd = parcelRequire("5jPLd");
const $09645cc4a47fe3a9$export$2ee317ef8ccc699f = (moduleScopes)=>{
    const { currentFormState: currentFormState } = (0, $k7beR.useCurrentFormState)();
    const currentFormStateRef = (0, $eJOHy.useRef)(currentFormState);
    const viewType = (0, $kn9fY.useViewType)();
    /**
	 * We want to have an up-to-date data when this hook's
	 * returned function is being called in useSubmit callback function
	 * thats why we keep it in a ref object
	 */ currentFormStateRef.current = currentFormState;
    return (0, $eJOHy.useCallback)((fieldChanges)=>(0, $5jPLd.filterFieldsChangesBasedOnScopes)(fieldChanges, currentFormStateRef.current, viewType, moduleScopes), [
        moduleScopes,
        viewType
    ]);
};

});



parcelRegister("2UZJB", function(module, exports) {
$parcel$export(module.exports, "useIframeTimeout", () => $04cdc08a7fad0eb5$export$39fbc0513eb03420);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $iFaP4 = parcelRequire("iFaP4");

var $37KRf = parcelRequire("37KRf");

var $kn9fY = parcelRequire("kn9fY");
const $04cdc08a7fad0eb5$export$45f7ef64ce535ffd = 12000;
const $04cdc08a7fad0eb5$export$39fbc0513eb03420 = ({ forgeExtension: forgeExtension })=>{
    const timeoutRef = (0, $eJOHy.useRef)(undefined);
    const callbackRef = (0, $eJOHy.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($12DRg))));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iFaP4.useAnalyticsEvents)();
    const viewType = (0, $kn9fY.useViewType)();
    const onTimeout = (0, $eJOHy.useCallback)(()=>{
        const { id: id } = forgeExtension;
        (0, $37KRf.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'failed',
            actionSubject: 'jiraUiModifications.iframeTimeout',
            attributes: {
                timeoutAfter: `${$04cdc08a7fad0eb5$export$45f7ef64ce535ffd / 1000}s`,
                extensionId: id,
                viewType: viewType
            }
        });
    }, [
        forgeExtension,
        viewType,
        createAnalyticsEvent
    ]);
    (0, $eJOHy.useEffect)(()=>{
        callbackRef.current = onTimeout;
    }, [
        onTimeout
    ]);
    const setLoadingComplete = (0, $eJOHy.useCallback)(()=>{
        clearTimeout(timeoutRef.current);
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        // For details on why we need to evaluate the callback in this way, see
        // https://www.joshwcomeau.com/snippets/react-hooks/use-timeout/#explanation
        // tl;dr: it allows the latest version of `onTimeout` to be called, without
        // needing to cancel and start a new timer each time dependencies change
        const callback = ()=>callbackRef.current();
        timeoutRef.current = setTimeout(callback, $04cdc08a7fad0eb5$export$45f7ef64ce535ffd);
        return ()=>clearTimeout(timeoutRef.current);
    }, []);
    return {
        setLoadingComplete: setLoadingComplete
    };
};

});

parcelRegister("lkSzY", function(module, exports) {
$parcel$export(module.exports, "useScopeChecks", () => $c36004b6ad89fe2d$export$5b312a37a22a70a8);

var $cK90O = parcelRequire("cK90O");
const $c36004b6ad89fe2d$export$5b312a37a22a70a8 = (appInstallationScopes)=>{
    if (appInstallationScopes) {
        const appHasAllRequiredCoarseScopes = (0, $cK90O.REQUIRED_COARSE_SCOPES).every((requiredScope)=>appInstallationScopes.includes(requiredScope));
        if (appHasAllRequiredCoarseScopes) return true;
        return (0, $cK90O.REQUIRED_GRANULAR_SCOPES).every((requiredScope)=>appInstallationScopes.includes(requiredScope));
    }
    return false;
};

});
parcelRegister("cK90O", function(module, exports) {
$parcel$export(module.exports, "REQUIRED_GRANULAR_SCOPES", () => $ce575fbf7ff34e60$export$81920d3428c141d1);
$parcel$export(module.exports, "REQUIRED_COARSE_SCOPES", () => $ce575fbf7ff34e60$export$bdf22b2c717ce672);
// https://hello.atlassian.net/wiki/spaces/unbx/pages/1732638810/RFC+Set+of+scopes+to+be+required+in+UI+modifications+extension+point+in+GIC+location
const $ce575fbf7ff34e60$export$81920d3428c141d1 = [
    'read:project:jira',
    'read:issue-type:jira',
    'read:user-configuration:jira',
    'read:user:jira',
    'read:issue:jira',
    'read:priority:jira',
    'read:label:jira',
    'read:license:jira',
    'read:field:jira',
    'read:field-configuration:jira',
    'write:field-configuration:jira',
    'write:field.default-value:jira',
    'write:field:jira'
];
const $ce575fbf7ff34e60$export$bdf22b2c717ce672 = [
    'manage:jira-configuration',
    'read:jira-user',
    'read:jira-work',
    'write:jira-work'
];

});


parcelRegister("3Mk71", function(module, exports) {
$parcel$export(module.exports, "useThreeLOPromptProps", () => $c8cacf39048898e6$export$cb62ba9a2eb7a0b4);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $iFaP4 = parcelRequire("iFaP4");

var $4q3QN = parcelRequire("4q3QN");

var $37KRf = parcelRequire("37KRf");

var $9h2ZZ = parcelRequire("9h2ZZ");

var $aOOEb = parcelRequire("aOOEb");


var $kn9fY = parcelRequire("kn9fY");

var $6m5hL = parcelRequire("6m5hL");
const $c8cacf39048898e6$export$cb62ba9a2eb7a0b4 = ({ forgeExtension: forgeExtension })=>{
    const [hasBeenTracked, setHasBeenTracked] = (0, $eJOHy.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iFaP4.useAnalyticsEvents)();
    const { setUIModificationsConsentStatus: setUIModificationsConsentStatus } = (0, $9h2ZZ.useAdjustmentsContextActions)();
    const { appId: appId } = (0, $4q3QN.parseExtensionId)(forgeExtension.id);
    const viewType = (0, $kn9fY.useViewType)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const currentUIModificationsConsentStatus = (0, $aOOEb.useUIModificationsConsentStatusForApp)({
        appId: appId
    });
    const onConsentSuccess = (0, $eJOHy.useCallback)(()=>{
        setUIModificationsConsentStatus({
            appId: appId,
            status: (0, $8b3b0b63fd2cebd2$export$45ca911896c5084f)
        });
        (0, $37KRf.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'cleared',
            actionSubject: 'jiraUiModificationsObligatoryConsent'
        });
    }, [
        appId,
        createAnalyticsEvent,
        setUIModificationsConsentStatus
    ]);
    const onConsentInitialization = (0, $eJOHy.useCallback)(()=>{
        if (currentUIModificationsConsentStatus === (0, $8b3b0b63fd2cebd2$export$39d15f3568f5a72c)) {
            setUIModificationsConsentStatus({
                appId: appId,
                status: (0, $8b3b0b63fd2cebd2$export$d67d63332ce3ce38)
            });
            if (!hasBeenTracked) {
                (0, $37KRf.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'triggered',
                    actionSubject: 'jiraUiModifications.obligatoryConsent',
                    attributes: {
                        viewType: viewType
                    }
                });
                setHasBeenTracked(true);
            }
        }
    }, [
        appId,
        currentUIModificationsConsentStatus,
        setUIModificationsConsentStatus,
        hasBeenTracked,
        viewType,
        createAnalyticsEvent
    ]);
    const consentMessage = (0, $eJOHy.useMemo)(()=>{
        return formatMessage((0, $6m5hL.getConsentMessage)(viewType), {
            appTitle: forgeExtension.properties.title
        });
    }, [
        formatMessage,
        forgeExtension.properties.title,
        viewType
    ]);
    const threeLOPromptComponentPropsMethods = (0, $eJOHy.useMemo)(()=>({
            onConsentSuccess: onConsentSuccess,
            onConsentInitialization: onConsentInitialization,
            consentMessage: consentMessage
        }), [
        onConsentSuccess,
        onConsentInitialization,
        consentMessage
    ]);
    return threeLOPromptComponentPropsMethods;
};

});

parcelRegister("9sjDw", function(module, exports) {
$parcel$export(module.exports, "buildExtensionData", () => $e83b667fcbf13279$export$141a9933f8885d99);

const $e83b667fcbf13279$export$141a9933f8885d99 = (executionContext)=>{
    return {
        type: (0, $62e8215d7f5c5cb8$export$811b7f067a43b422),
        ...executionContext
    };
};

});



parcelRegister("5XQre", function(module, exports) {
$parcel$export(module.exports, "useAppsToRender", () => $41ed4f2fafa357ac$export$bef357953bcc2428);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $eJOHy = parcelRequire("eJOHy");

var $iFaP4 = parcelRequire("iFaP4");

var $37KRf = parcelRequire("37KRf");

var $9h2ZZ = parcelRequire("9h2ZZ");

var $kn9fY = parcelRequire("kn9fY");

var $aRf30 = parcelRequire("aRf30");


var $gzJMj = parcelRequire("gzJMj");
const $41ed4f2fafa357ac$export$bef357953bcc2428 = (payload)=>{
    const { data: data, executionContextKey: executionContextKey } = payload;
    const { startFieldsInitialisationTimeout: startFieldsInitialisationTimeout } = (0, $aRf30.useIssueAdjustmentsActions)();
    const { setAdjustmentsAreEnabled: setAdjustmentsAreEnabled, setHasFinishedLoading: setHasFinishedLoading } = (0, $9h2ZZ.useAdjustmentsContextActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iFaP4.useAnalyticsEvents)();
    const viewType = (0, $kn9fY.useViewType)();
    const configuredApps = (0, $eJOHy.useMemo)(()=>(0, $gzJMj.getConfiguredApps)(data.jira?.forge?.uiModificationsExtensions, data.jira?.uiModifications), [
        data.jira?.forge?.uiModificationsExtensions,
        data.jira?.uiModifications
    ]);
    const appsToRender = (0, $eJOHy.useMemo)(()=>{
        return configuredApps.slice(0, (0, $fb403b7f10cd061f$export$575c2f3c7fe81caa));
    }, [
        configuredApps
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (data.jira?.uiModifications !== undefined) setHasFinishedLoading(true);
    }, [
        setHasFinishedLoading,
        data.jira?.uiModifications
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (appsToRender.length > 0) {
            setAdjustmentsAreEnabled(true);
            startFieldsInitialisationTimeout({
                createAnalyticsEvent: createAnalyticsEvent
            });
        }
    }, [
        appsToRender,
        setAdjustmentsAreEnabled,
        startFieldsInitialisationTimeout,
        createAnalyticsEvent
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const configuredAppsCount = configuredApps.length;
        if (configuredAppsCount >= 1) (0, $37KRf.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.configuredAppsPerContext',
            attributes: {
                forgeModulesCount: data.jira?.forge?.uiModificationsExtensions.length,
                uimConfiguredAppCount: data.jira?.uiModifications.length,
                configuredAndInstalledApps: configuredAppsCount,
                areMultipleAppsConfiguredAndInstalled: configuredAppsCount > 1,
                viewType: viewType
            }
        });
    }, [
        // `executionContextKey` is required to track events when execution context changed
        executionContextKey,
        viewType,
        createAnalyticsEvent,
        configuredApps.length,
        data.jira?.forge?.uiModificationsExtensions.length,
        data.jira?.uiModifications.length
    ]);
    return appsToRender;
};

});
const $fb403b7f10cd061f$export$575c2f3c7fe81caa = 5;

parcelRegister("gzJMj", function(module, exports) {
$parcel$export(module.exports, "getConfiguredApps", () => $bdb5c56bebb971ba$export$6ead423ef319ea49);

var $foUHx = parcelRequire("foUHx");
const $bdb5c56bebb971ba$var$STABLE_EMPTY_ARRAY = [];
const $bdb5c56bebb971ba$export$6ead423ef319ea49 = (forgeExtensions, uiModificationsConfigs)=>{
    if (!forgeExtensions || !uiModificationsConfigs) return $bdb5c56bebb971ba$var$STABLE_EMPTY_ARRAY;
    // Put modules in the HashMap for a fast search & get by appEnvId
    const modulesHashMap = (0, $foUHx.normalizeExtensions)(forgeExtensions);
    return uiModificationsConfigs.filter((configuration)=>!!modulesHashMap[configuration.appEnvId]).map((configuration)=>({
            forgeExtension: modulesHashMap[configuration.appEnvId],
            uiModificationsConfig: configuration.uiModifications.map(({ id: id, data: data })=>({
                    id: id,
                    data: data
                }))
        }));
};

});
parcelRegister("foUHx", function(module, exports) {
$parcel$export(module.exports, "normalizeExtensions", () => $cc5260655448aa91$export$7e2e604b6166a087);

var $4q3QN = parcelRequire("4q3QN");
const $cc5260655448aa91$export$7e2e604b6166a087 = (forgeExtensions)=>forgeExtensions.reduce((accumulator, current)=>{
        const { appId: appId, environmentId: envId } = (0, $4q3QN.parseExtensionId)(current.id);
        const combinedAppEnvId = `${appId}/${envId}`;
        // by this condition we make sure the first IA module is rendered (appEnvId key is not overwritten)
        // and integration code is deterministic (if you add a new IA module,
        // the 1st one will be rendered, not the last one)
        if (!accumulator[combinedAppEnvId]) accumulator[combinedAppEnvId] = current;
        return accumulator;
    }, {});

});



parcelRegister("rh0Fi", function(module, exports) {
$parcel$export(module.exports, "useContextCleanup", () => $f25d2ef623724375$export$c704babd3a8c2350);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $eJOHy = parcelRequire("eJOHy");

var $9h2ZZ = parcelRequire("9h2ZZ");

var $kn9fY = parcelRequire("kn9fY");

var $aRf30 = parcelRequire("aRf30");

var $6m5hL = parcelRequire("6m5hL");
const $f25d2ef623724375$export$c704babd3a8c2350 = (payload)=>{
    const { executionContextKey: executionContextKey, numberOfSupportedFields: numberOfSupportedFields, resetFormFieldsCounter: resetFormFieldsCounter } = payload;
    const { resetAllFields: resetAllFields, triggerFieldInitialization: triggerFieldInitialization, setNumberOfSupportedFields: setNumberOfSupportedFields } = (0, $aRf30.useIssueAdjustmentsActions)();
    const { resetAdjustmentContext: resetAdjustmentContext } = (0, $9h2ZZ.useAdjustmentsContextActions)();
    const viewType = (0, $kn9fY.useViewType)();
    (0, $eJOHy.useEffect)(()=>{
        if (numberOfSupportedFields !== undefined) setNumberOfSupportedFields(numberOfSupportedFields);
        return ()=>setNumberOfSupportedFields(0);
    }, [
        numberOfSupportedFields,
        setNumberOfSupportedFields
    ]);
    (0, $eJOHy.useEffect)(()=>{
        triggerFieldInitialization();
        return resetAllFields;
    // Whenever the executionContextKey is changed, or the resetFormFieldsCounter
    // is incremented ("create another issue" GIC) we want to reset any data in our store.
    // For "create another issue" `resetFormFieldsCounter` we trigger re-initialization of field data.
    }, [
        executionContextKey,
        resetFormFieldsCounter,
        resetAllFields,
        triggerFieldInitialization
    ]);
    (0, $eJOHy.useEffect)(()=>()=>{
            resetAdjustmentContext();
            (0, $6m5hL.getAnalytics)(viewType).cancelTTI();
        }, // When executionContextKey is changed we reset the AdjustmentsContext because
    // other executionContextKey may not be configured to run UI modifications
    [
        executionContextKey,
        resetAdjustmentContext,
        viewType
    ]);
};

});

parcelRegister("220X3", function(module, exports) {
$parcel$export(module.exports, "useEnrichedExecutionContext", () => $c4f3a20cc178490c$export$649da33b72723913);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $kn9fY = parcelRequire("kn9fY");
const $c4f3a20cc178490c$export$649da33b72723913 = ({ executionContext: executionContext })=>{
    (0, $gRw8I.di)((0, $kn9fY.useViewType));
    const viewType = (0, $kn9fY.useViewType)();
    const enrichedExecutionContext = (0, $eJOHy.useMemo)(()=>{
        return executionContext && {
            ...executionContext,
            viewType: viewType
        };
    }, [
        executionContext,
        viewType
    ]);
    return enrichedExecutionContext;
};

});





//# sourceMappingURL=async-ui-modifications-root-entrypoint.32e10b12.js.map
